import { useState, useEffect, useCallback, useRef } from 'react';
import DataTable, { Rozet } from './DataTable';
import { createPortal } from 'react-dom';
import DatePicker from './DatePicker';
import { apiRequest } from '../services/api';
import { vergiCarpani } from '../utils/vergi';
import { useAuth } from '../context/AuthContext';
import { useKasa } from '../context/KasaContext';
import YeniFaturaModal from './YeniFaturaModal';

const tabs = ['Rezervasyon', 'Ödemeler', 'Adisyonlar', 'E-fatura', 'Evraklar', 'Log'];

const inputClass = "w-full border border-slate-200 rounded-2xl px-3 py-2.5 text-sm bg-white focus:outline-none focus:ring-2 focus:ring-indigo-400 focus:border-transparent hover:border-indigo-300 transition-all";
const labelClass = "text-[10px] font-black uppercase tracking-widest text-slate-500 mb-1.5 block";

function MiniPopup({ title, onClose, children, wide }) {
  return (
    <div className="fixed inset-0 z-[10100] flex items-center justify-center p-3 sm:p-4"
      style={{ backdropFilter: 'blur(12px)', background: 'rgba(15,23,42,0.65)' }}>
      <div className={`bg-white/95 backdrop-blur-xl rounded-[2rem] shadow-2xl w-full ${wide ? 'max-w-2xl' : 'max-w-lg'} max-h-[90vh] flex flex-col border border-white/20`}
        style={{ animation: 'fadeIn 0.2s ease-out' }}>
        <div className="flex items-center justify-between px-5 py-4 bg-gradient-to-r from-indigo-600 to-violet-600 rounded-t-[2rem] flex-shrink-0">
          <h3 className="font-black text-white text-[11px] uppercase tracking-widest truncate pr-2">{title}</h3>
          <button onClick={onClose} className="w-8 h-8 bg-white/15 hover:bg-white/25 rounded-2xl flex items-center justify-center text-white font-black transition-all flex-shrink-0 text-sm">✕</button>
        </div>
        <div className="p-4 sm:p-6 overflow-y-auto">{children}</div>
      </div>
    </div>
  );
}

function MisafirDuzenlePopup({ misafir, onClose, onKaydedildi }) {
  const bugun = new Date();
  const fmtDate = d => d ? `${String(d.getDate()).padStart(2, '0')}.${String(d.getMonth() + 1).padStart(2, '0')}.${d.getFullYear()}` : '';
  const parseDate = str => { if (!str) return null; const [g, a, y] = str.split('.').map(Number); return new Date(y, a - 1, g).toISOString(); };

  const [form, setForm] = useState({
    misafirId: misafir.misafirId,
    adSoyad: misafir.adSoyad || '',
    tcPasaportNo: misafir.tcPasaportNo || '',
    dogumTarihi: misafir.dogumTarihi ? fmtDate(new Date(misafir.dogumTarihi)) : '',
    ulke: misafir.ulke || 'TÜRKİYE',
    telefon: misafir.telefon || '',
    email: misafir.email || '',
    cinsiyet: misafir.cinsiyet || '',
    sehir: misafir.sehir || '',
    adres: misafir.adres || '',
  });
  const [kaydediliyor, setKaydediliyor] = useState(false);
  const [hata, setHata] = useState('');

  const set = (k, v) => setForm(p => ({ ...p, [k]: v }));

  async function handleKaydet() {
    if (!form.adSoyad.trim()) { setHata('Ad soyad zorunludur.'); return; }
    setKaydediliyor(true); setHata('');
    try {
      await apiRequest('misafirler', 'PUT', {
        ...form,
        dogumTarihi: parseDate(form.dogumTarihi),
      });
      onKaydedildi?.();
      onClose();
    } catch { setHata('Kayıt sırasında hata oluştu.'); }
    setKaydediliyor(false);
  }

  return (
    <MiniPopup title={`Misafir Düzenle — ${misafir.adSoyad}`} onClose={onClose} wide>
      <div className="space-y-4">
        {hata && <div className="bg-red-50 border border-red-200 rounded-xl px-4 py-3 text-sm text-red-600">⚠️ {hata}</div>}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          <div className="col-span-1 sm:col-span-2">
            <label className={labelClass}>Ad Soyad</label>
            <input value={form.adSoyad} onChange={e => set('adSoyad', e.target.value)} className={inputClass} autoFocus />
          </div>
          <div>
            <label className={labelClass}>T.C. / Pasaport No</label>
            <input value={form.tcPasaportNo} onChange={e => set('tcPasaportNo', e.target.value)} className={inputClass} />
          </div>
          <div>
            <label className={labelClass}>Cinsiyet</label>
            <select value={form.cinsiyet} onChange={e => set('cinsiyet', e.target.value)} className={inputClass}>
              <option value="">Seçiniz</option>
              <option>Erkek</option><option>Kadın</option>
            </select>
          </div>
          <div>
            <label className={labelClass}>Doğum Tarihi</label>
            <DatePicker value={form.dogumTarihi} onChange={v => set('dogumTarihi', v)} />
          </div>
          <div>
            <label className={labelClass}>Ülke</label>
            <input value={form.ulke} onChange={e => set('ulke', e.target.value)} className={inputClass} />
          </div>
          <div>
            <label className={labelClass}>Telefon</label>
            <input value={form.telefon} onChange={e => set('telefon', e.target.value)} className={inputClass} />
          </div>
          <div>
            <label className={labelClass}>E-mail</label>
            <input value={form.email} onChange={e => set('email', e.target.value)} className={inputClass} />
          </div>
          <div>
            <label className={labelClass}>Şehir</label>
            <input value={form.sehir} onChange={e => set('sehir', e.target.value)} className={inputClass} />
          </div>
          <div className="col-span-1 sm:col-span-2">
            <label className={labelClass}>Adres</label>
            <input value={form.adres} onChange={e => set('adres', e.target.value)} className={inputClass} />
          </div>
        </div>
        <div className="flex gap-3 pt-2 border-t border-slate-100">
          <button onClick={handleKaydet} disabled={kaydediliyor}
            className="flex-1 bg-gradient-to-r from-indigo-600 to-violet-600 hover:from-indigo-700 hover:to-violet-700 disabled:opacity-60 text-white py-2.5 rounded-2xl font-black text-[10px] uppercase tracking-widest transition-all shadow-md">
            {kaydediliyor ? '⏳ Kaydediliyor...' : '💾 Kaydet'}
          </button>
          <button onClick={onClose} className="bg-slate-100 hover:bg-slate-200 text-slate-600 px-5 py-2.5 rounded-2xl text-[10px] font-black uppercase tracking-widest">
            İptal
          </button>
        </div>
      </div>
    </MiniPopup>
  );
}

function MisafirEklePopup({ rezervasyonId, onClose, onEklendi }) {
  const [arama, setArama] = useState('');
  const [misafirler, setMisafirler] = useState([]);
  const [yukleniyor, setYukleniyor] = useState(true);
  const [ekleniyor, setEkleniyor] = useState(null);
  const [hata, setHata] = useState('');

  useEffect(() => {
    apiRequest('misafirler').then(d => { setMisafirler(d || []); setYukleniyor(false); }).catch(() => setYukleniyor(false));
  }, []);

  const aramaKucuk = arama.toLowerCase().trim();
  const filtrelenmis = aramaKucuk.length < 2 ? [] : misafirler.filter(m =>
    (m.adSoyad || '').toLowerCase().includes(aramaKucuk) ||
    (m.tcPasaportNo || '').toLowerCase().includes(aramaKucuk)
  ).slice(0, 20);

  async function handleEkle(m) {
    setEkleniyor(m.misafirId); setHata('');
    try {
      await apiRequest(`rezervasyonlar/${rezervasyonId}/misafir`, 'POST', { misafirId: m.misafirId, grupTip: 'Yetişkin' });
      onEklendi?.();
      onClose();
    } catch { setHata('Eklenemedi.'); }
    setEkleniyor(null);
  }

  return (
    <MiniPopup title="Rezervasyona Misafir Ekle" onClose={onClose}>
      <div className="space-y-4">
        <div>
          <label className={labelClass}>Ad Soyad veya T.C. ile ara</label>
          <input
            autoFocus
            value={arama}
            onChange={e => setArama(e.target.value)}
            placeholder="En az 2 karakter yazın..."
            className={inputClass}
          />
        </div>
        {hata && <div className="bg-red-50 border border-red-200 rounded-xl px-4 py-3 text-sm text-red-600">{hata}</div>}
        {yukleniyor && <p className="text-center text-slate-400 text-sm py-4">Yükleniyor...</p>}
        {!yukleniyor && aramaKucuk.length >= 2 && filtrelenmis.length === 0 && (
          <p className="text-center text-slate-400 text-sm py-4">Sonuç bulunamadı.</p>
        )}
        {filtrelenmis.length > 0 && (
          <div className="space-y-2 max-h-64 overflow-y-auto">
            {filtrelenmis.map(m => (
              <div key={m.misafirId} className="flex items-center justify-between bg-slate-50 hover:bg-indigo-50 border border-slate-100 rounded-xl px-4 py-3 transition-colors">
                <div>
                  <p className="text-sm font-bold text-slate-800">{m.adSoyad}</p>
                  <p className="text-[10px] text-slate-400 font-mono">{m.tcPasaportNo || '—'}</p>
                </div>
                <button
                  onClick={() => handleEkle(m)}
                  disabled={ekleniyor === m.misafirId}
                  className="bg-indigo-600 hover:bg-indigo-700 disabled:bg-indigo-300 text-white text-xs font-black px-4 py-2 rounded-xl transition-colors"
                >
                  {ekleniyor === m.misafirId ? '...' : 'Ekle'}
                </button>
              </div>
            ))}
          </div>
        )}
      </div>
    </MiniPopup>
  );
}

function OdemeAlPopup({ onClose, rezervasyonId, personelId, onKaydedildi, kalanBakiye }) {
  const bugun = new Date();
  const fmt = d => [String(d.getDate()).padStart(2, '0'), String(d.getMonth() + 1).padStart(2, '0'), d.getFullYear()].join('.');
  const { paraBirimleri, dovizKurlari } = useKasa();
  const [aciklama, setAciklama] = useState('Rez. ödemesi');
  const [tutar, setTutar] = useState('');
  const [paraBirimi, setParaBirimi] = useState('TL');
  const [odemeTipi, setOdemeTipi] = useState('NAKİT');
  const [bankaAdi, setBankaAdi] = useState('');
  const [tarih, setTarih] = useState(fmt(bugun));
  const [saat, setSaat] = useState(`${String(bugun.getHours()).padStart(2, '0')}:${String(bugun.getMinutes()).padStart(2, '0')}`);
  const [kaydediliyor, setKaydediliyor] = useState(false);
  const [hata, setHata] = useState('');
  const [bankalar, setBankalar] = useState([]);
  const [odemeTipleriDB, setOdemeTipleriDB] = useState([]);

  const paraBirimiListesi = (paraBirimleri || []).map(p => p.tcmbKod || p.ad || p).filter(Boolean);
  const kurDegeri = dovizKurlari[paraBirimi] || 1;
  const tlKarsiligi = paraBirimi !== 'TL' && tutar > 0 ? (parseFloat(tutar) * kurDegeri).toFixed(2) : null;
  const tutarTL = parseFloat(tutar) > 0 ? parseFloat(tutar) * kurDegeri : 0;
  const fazlaOdeme = kalanBakiye != null && kalanBakiye > 0 && tutarTL > kalanBakiye;

  useEffect(() => {
    apiRequest('bankatanimlari').then(d => setBankalar(d || [])).catch(() => { });
    apiRequest('odemetipleri').then(d => setOdemeTipleriDB(d || [])).catch(() => { });
  }, []);

  const parseTarih = (str) => {
    if (!str) return new Date();
    const [g, a, y] = str.split('.').map(Number);
    const [sa, dk] = (saat || '00:00').split(':').map(Number);
    return new Date(y, a - 1, g, sa, dk);
  };

  async function handleKaydet() {
    if (!tutar || parseFloat(tutar) <= 0) { setHata('Geçerli bir tutar giriniz.'); return; }
    setKaydediliyor(true); setHata('');
    try {
      await apiRequest('odemeler', 'POST', {
        aciklama, tutar: parseFloat(tutar), paraBirimi,
        kurDegeri: paraBirimi === 'TL' ? 1 : kurDegeri,
        odemeTipi, bankaAdi,
        odemeTarihi: parseTarih(tarih).toISOString(),
        odemeSaati: saat,
        rezervasyonId, personelId,
      });
      onKaydedildi?.();
      onClose();
    } catch { setHata('Kayıt sırasında hata oluştu.'); }
    setKaydediliyor(false);
  }

  return (
    <MiniPopup title="Ödeme Al" onClose={onClose}>
      <div className="space-y-4">
        {hata && <div className="bg-red-50 border border-red-200 rounded-xl px-4 py-3 text-sm text-red-600">⚠️ {hata}</div>}
        <div><label className={labelClass}>Açıklama</label><input value={aciklama} onChange={e => setAciklama(e.target.value)} className={inputClass} /></div>
        <div className="flex gap-3">
          <div className="flex-1"><label className={labelClass}>Tutar</label>
            <input type="number" value={tutar} onChange={e => setTutar(e.target.value)} className={inputClass} placeholder="0.00" autoFocus />
          </div>
          <div className="w-28"><label className={labelClass}>Para Birimi</label>
            <select value={paraBirimi} onChange={e => setParaBirimi(e.target.value)} className={inputClass}>
              <option value="TL">TL</option>
              {paraBirimiListesi.filter(p => p !== 'TL' && p !== 'TRY').map(p => (
                <option key={p} value={p}>{p}</option>
              ))}
            </select>
          </div>
        </div>
        {tlKarsiligi && (
          <div className="text-xs text-slate-500 bg-slate-50 rounded-lg px-3 py-2">
            ≈ {tlKarsiligi} TL (1 {paraBirimi} = {kurDegeri.toFixed(4)} TL)
          </div>
        )}
        {fazlaOdeme && (
          <div className="bg-amber-50 border border-amber-200 rounded-xl px-3 py-2.5 text-xs text-amber-700">
            ⚠️ Bu ödeme kalan bakiyeyi ({kalanBakiye.toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 4 })} TL) aşıyor. Fazla ödeme kaydedilecek.
          </div>
        )}
        <div><label className={labelClass}>Ödeme Tipi</label>
          <select value={odemeTipi} onChange={e => setOdemeTipi(e.target.value)} className={inputClass}>
            {(odemeTipleriDB.length > 0 ? odemeTipleriDB.map(o => o.ad) : ['NAKİT', 'KREDİ KARTI', 'BANKA HAVALE', 'ÇEK']).map(t => (
              <option key={t}>{t}</option>
            ))}
          </select>
        </div>
        {(odemeTipi.localeCompare('NAKİT', 'tr', { sensitivity: 'base' }) !== 0 && bankalar.length > 0) && (
          <div><label className={labelClass}>Banka</label>
            <select value={bankaAdi} onChange={e => setBankaAdi(e.target.value)} className={inputClass}>
              <option value="">Seçiniz</option>
              {bankalar.map(b => <option key={b.bankaTanimiId} value={b.ad}>{b.ad}</option>)}
            </select>
          </div>
        )}
        <div><label className={labelClass}>Tarih</label><DatePicker value={tarih} onChange={setTarih} /></div>
        <div><label className={labelClass}>Saat</label><input type="time" value={saat} onChange={e => setSaat(e.target.value)} className={inputClass} /></div>
        <button onClick={handleKaydet} disabled={kaydediliyor}
          className="w-full bg-gradient-to-r from-indigo-600 to-violet-600 hover:from-indigo-700 hover:to-violet-700 disabled:opacity-60 text-white py-3 rounded-2xl font-black text-[10px] uppercase tracking-widest transition-all shadow-md">
          {kaydediliyor ? '⏳ Kaydediliyor...' : '💾 Kaydet — Kasaya Ekle'}
        </button>
      </div>
    </MiniPopup>
  );
}

function CheckOutPopup({ onClose, rez, onCheckOut, onOdemeAc }) {
  let odaTutar = rez?.odaTutari || 0;

  // Belirsiz çıkışlı rezervasyonlarda gerçek konaklama süresine göre hesapla
  if (!rez?.cikisTarihi && rez?.girisTarihi) {
    const giris = new Date(rez.girisTarihi);
    const bugun = new Date();
    const gece = Math.floor(
      (Date.UTC(bugun.getFullYear(), bugun.getMonth(), bugun.getDate()) -
        Date.UTC(giris.getFullYear(), giris.getMonth(), giris.getDate())) /
      (1000 * 60 * 60 * 24)
    );
    if (gece > 0) {
      if (rez.fiyatTipi === 'Gecelik ücret') {
        odaTutar = odaTutar * gece;
      } else if (rez.fiyatTipi === 'Kişi başı ücret') {
        odaTutar = odaTutar * gece * (rez.kisiSayisi || 1);
      }
    }
  }

  const adisyon = rez?.adisyonToplam || 0;
  const alinan = rez?.alinanToplam || 0;
  const kalan = Math.max(0, odaTutar + adisyon - alinan);
  const bakiyeVar = kalan > 0;
  const [yukleniyor, setYukleniyor] = useState(false);

  async function handleCheckOut() {
    setYukleniyor(true);
    try {
      await apiRequest(`rezervasyonlar/${rez.rezervasyonId}/check-out`, 'PATCH');
      onCheckOut?.();
      onClose();
    } catch (e) { alert(e?.message || 'Check-OUT işlemi başarısız.'); }
    setYukleniyor(false);
  }

  return (
    <MiniPopup title={bakiyeVar ? "Ödenmemiş Bakiye" : "Check-OUT Onayı"} onClose={onClose}>
      <div className="space-y-4">
        <div className="border border-slate-200 rounded-xl overflow-hidden">
          {[
            { label: 'Rezervasyon tutarı', value: odaTutar.toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 4 }) + ' TL' },
            { label: 'Adisyon tutarı', value: adisyon.toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 4 }) + ' TL' },
            { label: 'Alınan ödeme', value: '−' + alinan.toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 4 }) + ' TL' },
            { label: 'Kalan bakiye', value: kalan.toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 4 }) + ' TL', bold: true, red: bakiyeVar },
          ].map((r, i) => (
            <div key={i} className={`flex justify-between px-4 py-2.5 text-sm
              ${i % 2 === 0 ? 'bg-white' : 'bg-slate-50'}
              ${r.bold ? 'font-bold' : 'text-slate-600'}
              ${r.red ? 'text-red-600' : ''}`}>
              <span>{r.label}</span><span>{r.value}</span>
            </div>
          ))}
        </div>
        {bakiyeVar ? (
          <>
            <div className="bg-amber-50 border border-amber-200 rounded-xl px-4 py-3 text-sm text-amber-700">
              <p className="font-bold mb-1">⚠️ Ödenmemiş Bakiye</p>
              <p>Misafirin <span className="font-bold">{kalan.toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 4 })} TL</span> ödenmemiş bakiyesi bulunmaktadır.</p>
            </div>
            <div className="flex gap-2">
              <button onClick={() => { onClose(); onOdemeAc?.(); }}
                className="flex-1 bg-emerald-600 hover:bg-emerald-700 text-white px-4 py-2.5 rounded-2xl text-[10px] font-black uppercase tracking-widest">
                Ödeme Al
              </button>
              <button onClick={handleCheckOut} disabled={yukleniyor}
                className="flex-1 bg-amber-500 hover:bg-amber-600 disabled:opacity-60 text-white px-4 py-2.5 rounded-2xl text-[10px] font-black uppercase tracking-widest">
                {yukleniyor ? '⏳...' : 'Yine de Devam Et'}
              </button>
              <button onClick={onClose} className="bg-slate-100 hover:bg-slate-200 text-slate-700 px-4 py-2 rounded-2xl text-[10px] font-black uppercase tracking-widest">
                İptal
              </button>
            </div>
          </>
        ) : (
          <>
            <p className="text-sm text-slate-600">Misafirin bakiyesi bulunmamaktadır. Check-OUT onaylıyor musunuz?</p>
            <div className="flex gap-2">
              <button onClick={handleCheckOut} disabled={yukleniyor}
                className="flex-1 bg-gradient-to-r from-indigo-600 to-violet-600 hover:from-indigo-700 hover:to-violet-700 disabled:opacity-60 text-white px-4 py-2.5 rounded-2xl text-[10px] font-black uppercase tracking-widest">
                {yukleniyor ? '⏳...' : '✅ Çıkışı Onayla'}
              </button>
              <button onClick={onClose} className="bg-slate-100 hover:bg-slate-200 text-slate-700 px-4 py-2 rounded-2xl text-[10px] font-black uppercase tracking-widest">
                İptal
              </button>
            </div>
          </>
        )}
      </div>
    </MiniPopup>
  );
}

const READONLY_GIZLI_ISLEMLER = ['Rezervasyonu İptal Et', 'Temizlik Talebi', 'Bakiyelendir'];

function DigerIslemlerDropdown({ onClose, onAction, pos, readonly }) {
  const gruplar = [
    {
      baslik: 'Rezervasyon',
      items: [
        { icon: '🏨', label: 'Konaklama Formu' },
        { icon: '📝', label: 'Rezervasyon Formu' },
        { icon: '🔴', label: 'Rezervasyonu İptal Et', danger: true },
      ]
    },
    {
      baslik: 'Oda',
      items: [
        { icon: '🧹', label: 'Temizlik Talebi' },
      ]
    },
    {
      baslik: 'Muhasebe',
      items: [
        { icon: '⚖️', label: 'Bakiyelendir' },
        { icon: '👤', label: 'Cariye Aktar' },
      ]
    },
  ].map(g => ({ ...g, items: readonly ? g.items.filter(i => !READONLY_GIZLI_ISLEMLER.includes(i.label)) : g.items }))
    .filter(g => g.items.length > 0);

  return (
    <>
      <div className="fixed inset-0 z-[10200]" onClick={onClose} />
      <div className="fixed bg-white border border-slate-200 rounded-2xl shadow-2xl z-[10205] w-56 overflow-y-auto"
        style={{ animation: 'fadeIn 0.15s ease-out', maxHeight: '380px', right: Math.max(pos.right, 4), top: Math.max(pos.top - 388, 8) }}>
        {gruplar.map((grup, gIdx) => (
          <div key={grup.baslik}>
            <div className="px-4 py-1.5 text-[10px] font-bold text-slate-400 uppercase tracking-wide border-b border-slate-100 mt-1">
              {grup.baslik}
            </div>
            {grup.items.map(item => (
              <button key={item.label} onClick={() => { onAction(item.label); onClose(); }}
                className={`w-full text-left px-4 py-2 text-sm flex items-center gap-2 transition-colors
                  ${item.danger
                    ? 'text-red-600 hover:bg-red-50'
                    : 'text-slate-700 hover:bg-indigo-50 hover:text-indigo-700'
                  }`}>
                <span className="text-base">{item.icon}</span>{item.label}
              </button>
            ))}
          </div>
        ))}
      </div>
    </>
  );
}

const durumRenk = (durum) => {
  if (!durum) return 'bg-amber-100 text-amber-700 ring-1 ring-amber-200';
  if (durum.includes('C-IN')) return 'bg-emerald-100 text-emerald-700 ring-1 ring-emerald-200';
  if (durum.includes('C-OUT')) return 'bg-blue-100 text-blue-700 ring-1 ring-blue-200';
  if (durum.includes('İptal')) return 'bg-red-100 text-red-700 ring-1 ring-red-200';
  return 'bg-amber-100 text-amber-700 ring-1 ring-amber-200';
};

function EvraklarTab({ rezervasyonId, readonly, onLogGuncelle }) {
  const [evraklar, setEvraklar] = useState([]);
  const [yukleniyor, setYukleniyor] = useState(true);
  const [yuklemede, setYuklemede] = useState(false);
  const inputRef = useRef(null);
  // REACT_APP_API_URL = "https://host/api" — upload için /api olmadan host lazım
  const API_URL  = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';
  const STATIC_BASE = API_URL.replace(/\/api\/?$/, ''); // statik dosyalar için

  const yukle = async () => {
    try {
      const data = await apiRequest(`evrak/rezervasyon/${rezervasyonId}`);
      setEvraklar(data || []);
    } catch { setEvraklar([]); }
    finally { setYukleniyor(false); }
  };

  useEffect(() => { yukle(); }, [rezervasyonId]);

  const handleDosyaSec = async (e) => {
    const dosya = e.target.files?.[0];
    if (!dosya) return;
    setYuklemede(true);
    try {
      const form = new FormData();
      form.append('dosya', dosya);
      const res = await fetch(`${API_URL}/evrak/rezervasyon/${rezervasyonId}`, {
        method: 'POST',
        credentials: 'include',
        body: form,
      });
      if (!res.ok) {
        const err = await res.json().catch(() => ({}));
        alert(err.message || 'Yükleme başarısız.');
        return;
      }
      await yukle();
      onLogGuncelle?.();
    } catch (e) { alert(e?.message || 'Yükleme başarısız.'); }
    finally { setYuklemede(false); e.target.value = ''; }
  };

  const handleSil = async (evrakId) => {
    if (!window.confirm('Evrak silinsin mi?')) return;
    try {
      await apiRequest(`evrak/${evrakId}`, 'DELETE');
      setEvraklar(p => p.filter(e => e.evrakId !== evrakId));
      onLogGuncelle?.();
    } catch (e) { alert(e?.message || 'Silme başarısız.'); }
  };

  const ikonRenk = (uzanti) => {
    if (['.jpg', '.jpeg', '.png', '.gif', '.webp'].includes(uzanti)) return { bg: 'bg-blue-50 text-blue-600', icon: '🖼' };
    if (uzanti === '.pdf') return { bg: 'bg-red-50 text-red-600', icon: '📄' };
    return { bg: 'bg-slate-50 text-slate-500', icon: '📎' };
  };

  const boyutYaz = (bytes) => {
    if (bytes < 1024) return `${bytes} B`;
    if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
    return `${(bytes / 1024 / 1024).toFixed(1)} MB`;
  };

  return (
    <div className="p-4 md:p-6 space-y-4" style={{ animation: 'slideIn 0.2s ease-out' }}>
      {!readonly && (
        <div className="bg-white rounded-2xl border border-slate-100 shadow-sm p-4">
          <p className="text-[10px] font-black uppercase tracking-widest text-slate-400 mb-3">Evrak Yükle</p>
          <input ref={inputRef} type="file" accept=".jpg,.jpeg,.png,.gif,.webp,.pdf" className="hidden" onChange={handleDosyaSec} />
          <button
            onClick={() => inputRef.current?.click()}
            disabled={yuklemede}
            className="w-full border-2 border-dashed border-slate-200 hover:border-indigo-300 rounded-2xl py-6 flex flex-col items-center gap-2 text-slate-400 hover:text-indigo-500 transition-colors disabled:opacity-50"
          >
            <span className="text-3xl">{yuklemede ? '⏳' : '📁'}</span>
            <span className="text-xs font-semibold">{yuklemede ? 'Yükleniyor...' : 'Dosya seç veya buraya tıkla'}</span>
            <span className="text-[10px]">JPG, PNG, GIF, WEBP, PDF — maks. 5 MB</span>
          </button>
        </div>
      )}

      {yukleniyor ? (
        <div className="flex justify-center py-8">
          <div className="w-8 h-8 border-2 border-indigo-500 border-t-transparent rounded-full animate-spin" />
        </div>
      ) : evraklar.length === 0 ? (
        <div className="bg-white rounded-2xl border border-slate-100 shadow-sm p-10 text-center text-slate-400">
          <div className="w-12 h-12 bg-slate-100 rounded-2xl flex items-center justify-center text-2xl mx-auto mb-3">📁</div>
          <p className="text-sm">Henüz evrak yüklenmemiş</p>
        </div>
      ) : (
        <div className="space-y-2">
          {evraklar.map(ev => {
            const { bg, icon } = ikonRenk(ev.dosyaUzantisi);
            return (
              <div key={ev.evrakId} className="bg-white rounded-2xl border border-slate-100 shadow-sm p-3 flex items-center gap-3">
                <div className={`w-10 h-10 rounded-xl flex items-center justify-center text-xl flex-shrink-0 ${bg}`}>{icon}</div>
                <div className="flex-1 min-w-0">
                  <p className="text-sm font-semibold text-slate-700 truncate">{ev.ad}{ev.dosyaUzantisi}</p>
                  <p className="text-[10px] text-slate-400">{boyutYaz(ev.dosyaBoyutu)} · {ev.yuklemeTarihi}</p>
                </div>
                <a
                  href={`${STATIC_BASE}${ev.url}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-indigo-500 hover:text-indigo-700 text-xs font-bold px-2 py-1 rounded-lg hover:bg-indigo-50 transition-colors"
                >
                  Görüntüle
                </a>
                {!readonly && (
                  <button
                    onClick={() => handleSil(ev.evrakId)}
                    className="text-rose-400 hover:text-rose-600 text-xs font-bold px-2 py-1 rounded-lg hover:bg-rose-50 transition-colors"
                  >
                    Sil
                  </button>
                )}
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}

export default function RezervasyonDetayModal({ rezervasyonId, onClose, onGuncelle }) {
  const { personel } = useAuth();
  const { paraBirimleri, dovizKurlari } = useKasa();
  const [aktifTab, setAktifTab] = useState('Rezervasyon');
  const [popup, setPopup] = useState(null);
  const [digerAcik, setDigerAcik] = useState(false);
  const digerBtnRef = useRef(null);
  const [digerPos, setDigerPos] = useState({ top: 0, right: 0 });
  const [yukleniyor, setYukleniyor] = useState(true);
  const [kaydediliyor, setKaydediliyor] = useState(false);
  const [rez, setRez] = useState(null);
  const [odemeler, setOdemeler] = useState([]);
  const [adisyonlar, setAdisyonlar] = useState([]);
  // Tutarın içindeki vergi dökümü — beyan ve fatura için matrahın görünmesi gerekiyor
  const [vergiDokumu, setVergiDokumu] = useState(null);
  const [stoklar, setStoklar] = useState([]);
  const [misafirDropdownAcik, setMisafirDropdownAcik] = useState(false);
  const [misafirDropdownPos, setMisafirDropdownPos] = useState({ top: 0, left: 0 });
  const [misafirDuzenle, setMisafirDuzenle] = useState(null);
  const [misafirEkleAcik, setMisafirEkleAcik] = useState(false);

  const [loglar, setLoglar] = useState([]);
  const [logMesaj, setLogMesaj] = useState('');
  const [logTip, setLogTip] = useState('Bilgi');
  const [uzatmaModal, setUzatmaModal] = useState(null); // null | 'onay' | { basarili, mesaj }
  const [logKaydediliyor, setLogKaydediliyor] = useState(false);

  const [adForm, setAdForm] = useState({ stokId: null, stokAdi: '', miktar: 1, birimFiyat: 0, iskonto: 0, not: '' });
  const [stokArama, setStokArama] = useState('');
  const [adKaydediliyor, setAdKaydediliyor] = useState(false);
  const [adisyonOdeModal, setAdisyonOdeModal] = useState(null); // { adisyonId, stokAdi, toplamTutar }
  const [adisyonOdeForm, setAdisyonOdeForm] = useState({ odemeTipi: '', paraBirimi: 'TL', bankaAdi: '', tutar: '' });

  // E-Fatura tab state
  const [efaturaListesi, setEfaturaListesi] = useState([]);
  const [efaturaYukleniyor, setEfaturaYukleniyor] = useState(false);
  const [faturaModalAcik, setFaturaModalAcik] = useState(false);
  const paraBirimiListesi = (paraBirimleri || []).map(p => p.tcmbKod || p.ad || p).filter(Boolean);
  const [adisyonOdeniyor, setAdisyonOdeniyor] = useState(false);
  const [adisyonOdeTipleri, setAdisyonOdeTipleri] = useState([]);
  const [adisyonBankalar, setAdisyonBankalar] = useState([]);

  const [rezForm, setRezForm] = useState({});
  const [otomatikFiyat, setOtomatikFiyat] = useState(null);
  const [fiyatYukleniyor, setFiyatYukleniyor] = useState(false);

  const GUN_ADLARI = ['Pazar', 'Pazartesi', 'Salı', 'Çarşamba', 'Perşembe', 'Cuma', 'Cumartesi'];

  const parseTarihLocal = (str) => {
    if (!str) return null;
    const [g, a, y] = str.split('.').map(Number);
    return new Date(y, a - 1, g);
  };

  const gecelikFiyatHesapla = useCallback(async (girisTarihi) => {
    if (!girisTarihi || !rez?.odaId) return null;
    try {
      const odaData = await apiRequest(`oda`);
      const oda = odaData?.find(o => o.odaId === rez.odaId);
      if (!oda?.odaTipiId) return null;
      const toISO = (ddMMyyyy) => ddMMyyyy.split('.').reverse().join('-');
      const girisISO = toISO(girisTarihi);
      const [fiyatData, carpanData] = await Promise.all([
        apiRequest(`odafiyat/${oda.odaTipiId}`),
        apiRequest(`dolulukfiyat/carpan?odaTipiId=${oda.odaTipiId}&giris=${girisISO}`).catch(() => null),
      ]);
      if (!fiyatData) return null;
      const giris = parseTarihLocal(girisTarihi);
      const isoGun = `${giris.getFullYear()}-${String(giris.getMonth()+1).padStart(2,'0')}-${String(giris.getDate()).padStart(2,'0')}`;
      const rezPb = rez.paraBirimi || 'TRY';
      const getKur = (pb) => (pb && pb !== 'TL' && pb !== 'TRY' && dovizKurlari[pb] > 0) ? dovizKurlari[pb] : 1;
      const rezKur = getKur(rezPb);
      const gunlukPb = fiyatData.gunlukFiyatlar?.[0]?.paraBirimi || 'TRY';
      const gunlukKur = getKur(gunlukPb);
      const fiyatDonustur = (f, kaynakKur) => Math.round((f || 0) * kaynakKur / rezKur * 100) / 100;
      const carpan = carpanData?.carpan ?? 1;
      const ozel = fiyatData.ozelFiyatlar?.find(f =>
        f.baslangicTarihi?.slice(0, 10) <= isoGun && f.bitisTarihi?.slice(0, 10) >= isoGun
      );
      let odaGecelik;
      if (ozel) {
        odaGecelik = fiyatDonustur(ozel.fiyat, getKur(ozel.paraBirimi || gunlukPb));
      } else {
        const gunAdi = GUN_ADLARI[giris.getDay()];
        const gunFiyat = fiyatData.gunlukFiyatlar?.find(f => f.gun === gunAdi);
        odaGecelik = fiyatDonustur(gunFiyat?.fiyat || 0, gunlukKur);
      }
      let odaGecelikCarpanli = Math.round(odaGecelik * carpan);

      // Firma rezervasyonuysa, firma gecelik fiyatını sivil fiyatın üzerine yaz
      if (rez?.firmaId) {
        const firmalar = await apiRequest('firmalar').catch(() => []);
        const firma = firmalar?.find(f => f.firmaId === rez.firmaId);
        if (firma?.fiyatKurallari?.length > 0) {
          // Konaklama vergisi KDV matrahına dahil edilmez — oranlar toplanır, çarpılmaz.
          const totalCarpan = vergiCarpani(firma.kdvOrani, firma.kdvDahilMi, firma.konaklamaVergisi);
          const uygunKurallar = firma.fiyatKurallari.filter(k => !k.odaTipiId || k.odaTipiId === oda.odaTipiId);
          const gecelikKural = uygunKurallar.find(k => k.fiyatTipi === 'gecelik');
          if (gecelikKural) {
            const fKur = getKur(gecelikKural.paraBirimi || 'TRY');
            odaGecelikCarpanli = Math.round(fiyatDonustur(Number(gecelikKural.fiyat), fKur) * totalCarpan);
          }
        }
      }

      return { fiyat: odaGecelikCarpanli + (rez.pansiyonEkFiyat || 0), pb: rezPb, carpanMesaj: carpanData?.mesaj || null };
    } catch { return null; }
  }, [rez?.odaId, rez?.firmaId, rez?.pansiyonEkFiyat, rez?.paraBirimi, dovizKurlari]);

  const fiyatHesapla = useCallback(async () => {
    if (!rezForm.girisTarihi || !rezForm.cikisTarihi || rezForm.cikisBelir || !rez?.odaId) return;
    setFiyatYukleniyor(true);
    try {
      const odaData = await apiRequest(`oda`);
      const oda = odaData?.find(o => o.odaId === rez.odaId);
      if (!oda?.odaTipiId) return;

      const toISO = (ddMMyyyy) => ddMMyyyy.split('.').reverse().join('-');
      const [fiyatData, carpanData] = await Promise.all([
        apiRequest(`odafiyat/${oda.odaTipiId}`),
        apiRequest(`dolulukfiyat/carpan?odaTipiId=${oda.odaTipiId}&giris=${toISO(rezForm.girisTarihi)}&cikis=${toISO(rezForm.cikisTarihi)}`).catch(() => null),
      ]);
      if (!fiyatData) return;

      const giris = parseTarihLocal(rezForm.girisTarihi);
      const cikis = parseTarihLocal(rezForm.cikisTarihi);
      const gece = Math.round((cikis - giris) / 86400000);
      if (gece <= 0) return;

      const carpan = carpanData?.carpan ?? 1;
      const pansiyonEk = rez.pansiyonEkFiyat || 0;
      const rezPb = rez.paraBirimi || 'TRY';

      // Saklanan paraBiriminden → TL → rez.paraBirimine dönüştürme
      const getKur = (pb) => (pb && pb !== 'TL' && pb !== 'TRY' && dovizKurlari[pb] > 0) ? dovizKurlari[pb] : 1;
      const rezKur = getKur(rezPb);
      const gunlukPb = fiyatData.gunlukFiyatlar?.[0]?.paraBirimi || 'TRY';
      const gunlukKur = getKur(gunlukPb);
      const kisiBasiPb = fiyatData.kisiBasiFiyatlar?.[0]?.paraBirimi || 'TRY';
      const kisiBasiKur = getKur(kisiBasiPb);
      const fiyatDonustur = (f, kaynakKur) => Math.round((f || 0) * kaynakKur / rezKur * 100) / 100;

      // Günlük fiyat hesapla (kaynak paraBirimi → rez paraBirimi), doluluk carpan oda fiyatına uygulanır
      let odaToplam = 0;
      for (let i = 0; i < gece; i++) {
        const gun = new Date(giris); gun.setDate(giris.getDate() + i);
        const isoGun = `${gun.getFullYear()}-${String(gun.getMonth()+1).padStart(2,'0')}-${String(gun.getDate()).padStart(2,'0')}`;
        const ozel = fiyatData.ozelFiyatlar?.find(f => f.baslangicTarihi?.slice(0, 10) <= isoGun && f.bitisTarihi?.slice(0, 10) >= isoGun);
        if (ozel) { odaToplam += fiyatDonustur(ozel.fiyat, getKur(ozel.paraBirimi || gunlukPb)); continue; }
        const gunAdi = GUN_ADLARI[gun.getDay()];
        const gunFiyat = fiyatData.gunlukFiyatlar?.find(f => f.gun === gunAdi);
        odaToplam += fiyatDonustur(gunFiyat?.fiyat || 0, gunlukKur);
      }
      let odaToplami = Math.round(odaToplam * carpan);
      let toplamFiyat = odaToplami + pansiyonEk * gece;

      // Kişi bazlı fiyat hesapla (kaynak paraBirimi → rez paraBirimi), doluluk carpan oda fiyatına uygulanır
      let kisiBasiHesap = null;
      if (fiyatData.kisiBasiFiyatlar?.length > 0) {
        const misafirSayisi = Math.max(1, rez.rezervasyonMisafirler?.length || 1);
        const sirali = [...fiyatData.kisiBasiFiyatlar].sort((a, b) => a.kisiSayisi - b.kisiSayisi);
        const uygun = sirali.filter(k => k.kisiSayisi <= misafirSayisi).pop() || sirali[0];
        const kb_gecelikOda = Math.round(fiyatDonustur(uygun?.fiyat || 0, kisiBasiKur) * carpan);
        const kb_gecelik = kb_gecelikOda + pansiyonEk;
        kisiBasiHesap = { gunluk: kb_gecelik, pansiyonEk, toplam: kb_gecelik * gece, odaToplam: kb_gecelikOda * gece, gece, kisiSayisi: misafirSayisi };
      }

      // Eğer rezervasyon firmaya aitse, fiyatları sivil değil firmanın kurallarına göre ez
      if (rez?.firmaId) {
        const firmalar = await apiRequest('firmalar').catch(() => []);
        const firma = firmalar?.find(f => f.firmaId === rez.firmaId);
        if (firma?.fiyatKurallari?.length > 0) {
          // Konaklama vergisi KDV matrahına dahil edilmez — oranlar toplanır, çarpılmaz.
          const totalCarpan = vergiCarpani(firma.kdvOrani, firma.kdvDahilMi, firma.konaklamaVergisi);
          const uygunFirmalar = firma.fiyatKurallari.filter(k => !k.odaTipiId || k.odaTipiId === oda.odaTipiId);

          const gecelikKural = uygunFirmalar.find(k => k.fiyatTipi === 'gecelik');
          if (gecelikKural) {
            const kb_kur = getKur(gecelikKural.paraBirimi || 'TRY');
            const f = fiyatDonustur(Number(gecelikKural.fiyat), kb_kur);
            const gecelik = f * totalCarpan;
            odaToplami = gecelik * gece;
            toplamFiyat = odaToplami;
          }

          const kisiBasiKural = uygunFirmalar.find(k => k.fiyatTipi === 'kisi-basi');
          if (kisiBasiKural) {
            const kb_kur = getKur(kisiBasiKural.paraBirimi || 'TRY');
            const misafirSayisi = Math.max(1, rez.rezervasyonMisafirler?.length || 1);
            let kbToplam = 0;
            if (kisiBasiKural.kisiBasiTip === 'sabit') {
               kbToplam = Number(kisiBasiKural.fiyat) * misafirSayisi;
            } else if (kisiBasiKural.kisiBasiTip === 'kademeli') {
               const detaylar = [...(kisiBasiKural.kisiDetayFiyatlar || [])].sort((a, b) => a.kisiSirasi - b.kisiSirasi);
               for (let i = 1; i <= misafirSayisi; i++) {
                 const entry = detaylar.find(d => d.kisiSirasi === i) || detaylar[detaylar.length - 1];
                 kbToplam += Number(entry?.fiyat || 0);
               }
            }
            const f = fiyatDonustur(kbToplam, kb_kur);
            const kb_gecelik = f * totalCarpan;
            kisiBasiHesap = { gunluk: kb_gecelik, pansiyonEk: 0, toplam: kb_gecelik * gece, odaToplam: kb_gecelik * gece, gece, kisiSayisi: misafirSayisi };
          }
        }
      }

      setOtomatikFiyat({ toplam: toplamFiyat, odaToplam: odaToplami, pansiyonEk, gece, kisiBasiHesap, kisiBasiMevcut: kisiBasiHesap !== null, pb: rezPb, carpanMesaj: carpanData?.mesaj });
    } catch { /* sessiz */ }
    setFiyatYukleniyor(false);
  }, [rezForm.girisTarihi, rezForm.cikisTarihi, rezForm.fiyatTipi, rez?.odaId, rez?.rezervasyonMisafirler, rez?.pansiyonEkFiyat]);

  useEffect(() => {
    if (rezForm.girisTarihi && rezForm.cikisTarihi) fiyatHesapla();
  }, [rezForm.girisTarihi, rezForm.cikisTarihi]);

  // Misafir tipi fiyatı: tarih değişince gecelik fiyat × gece otomatik güncelle
  useEffect(() => {
    if (!rez?.misafirTipiId || !(rez?.misafirTipiGecelikFiyat > 0)) return;
    if (!rezForm.girisTarihi || !rezForm.cikisTarihi || rezForm.cikisBelir) return;
    try {
      const [g1, a1, y1] = rezForm.girisTarihi.split('.').map(Number);
      const [g2, a2, y2] = rezForm.cikisTarihi.split('.').map(Number);
      const gece = Math.max(0, Math.round((new Date(y2, a2 - 1, g2) - new Date(y1, a1 - 1, g1)) / 86400000));
      if (gece > 0) setRezForm(p => ({ ...p, odaTutari: rez.misafirTipiGecelikFiyat * gece }));
    } catch { }
  }, [rezForm.girisTarihi, rezForm.cikisTarihi, rezForm.cikisBelir, rez?.misafirTipiId, rez?.misafirTipiGecelikFiyat]);

  useEffect(() => {
    if (rezForm.cikisBelir && rezForm.girisTarihi) {
      // Misafir tipi fiyatı varsa onu kullan, yoksa odanın normal gecelik fiyatını çek
      if (rez?.misafirTipiId && rez?.misafirTipiGecelikFiyat > 0) {
        setRezForm(p => ({ ...p, odaTutari: rez.misafirTipiGecelikFiyat }));
      } else {
        gecelikFiyatHesapla(rezForm.girisTarihi).then(sonuc => {
          if (sonuc != null) setRezForm(p => ({ ...p, odaTutari: sonuc.fiyat }));
        });
      }
    }
  }, [rezForm.girisTarihi, rezForm.cikisBelir, rez?.misafirTipiId, rez?.misafirTipiGecelikFiyat]);

  const fmt = (isoStr) => {
    if (!isoStr) return '';
    // Backend local zaman döndürür (Z yok) — doğrudan yerel metodlarla oku
    const d = new Date(isoStr);
    return `${String(d.getDate()).padStart(2, '0')}.${String(d.getMonth() + 1).padStart(2, '0')}.${d.getFullYear()}`;
  };

  const veriYukle = useCallback(async () => {
    setYukleniyor(true);
    try {
      const [rezData, odemeData, adisyonData, logData] = await Promise.all([
        apiRequest(`rezervasyonlar/${rezervasyonId}`),
        apiRequest(`odemeler/rezervasyon/${rezervasyonId}`),
        apiRequest(`adisyonlar/rezervasyon/${rezervasyonId}`),
        apiRequest(`rezervasyon-loglari/rezervasyon/${rezervasyonId}`),
      ]);
      setRez(rezData);
      setOdemeler(odemeData || []);
      setAdisyonlar(adisyonData || []);
      setLoglar(logData || []);

      // Tutarın içindeki vergi dökümü — firma varsa onun oranlarıyla hesaplanır
      const tutar = Number(rezData?.odaTutari) || 0;
      if (tutar > 0) {
        const q = new URLSearchParams({ tutar });
        if (rezData?.firmaId) q.set('firmaId', rezData.firmaId);
        apiRequest(`vergi-ayari/dokum/rezervasyon?${q}`)
          .then(setVergiDokumu)
          .catch(() => setVergiDokumu(null));
      } else {
        setVergiDokumu(null);
      }
      setRezForm({
        girisTarihi: fmt(rezData.girisTarihi),
        cikisTarihi: rezData.cikisTarihi ? fmt(rezData.cikisTarihi) : '',
        cikisBelir: !rezData.cikisTarihi,
        belirsizKilit: !!rezData.belirsizCikisKilitGun,
        belirsizKilitGun: rezData.belirsizCikisKilitGun || 30,
        girisSaati: rezData.girisSaati || '14:00',
        cikisSaati: rezData.cikisSaati || '12:00',
        not: rezData.not || '',
        renkEtiketi: rezData.renkEtiketi || '#3B82F6',
        odaCheckInYapildi: rezData.odaCheckInYapildi || false,
        otomatikUzatmaAktif: rezData.otomatikUzatmaAktif || false,
        odaTutari: rezData.odaTutari || 0,
        fiyatTipi: rezData.fiyatTipi || 'Toplam fiyat',
        kisiSayisi: rezData.kisiSayisi || 1,
        paraBirimi: rezData.paraBirimi || 'TL',
        kurDegeri: rezData.kurDegeri || 1,
      });
    } catch { /* sessiz */ }
    setYukleniyor(false);
  }, [rezervasyonId]);

  // STOK EKSİKLİĞİ KONTROLÜ (Loglardan çekiyoruz)
  const eksikBukletLoglari = loglar?.filter(l => l.tip === 'Uyarı' && l.mesaj.includes('⚠️ STOK YETERSİZ')) || [];

  useEffect(() => {
    apiRequest('stok').then(d => setStoklar(d || [])).catch(() => { });
  }, []);

  useEffect(() => { veriYukle(); }, [veriYukle]);

  const efaturaYukle = useCallback(async () => {
    setEfaturaYukleniyor(true);
    try {
      const data = await apiRequest(`efatura/rezervasyon/${rezervasyonId}`);
      setEfaturaListesi(data || []);
    } catch { setEfaturaListesi([]); }
    setEfaturaYukleniyor(false);
  }, [rezervasyonId]);

  useEffect(() => { if (aktifTab === 'E-fatura') efaturaYukle(); }, [aktifTab, efaturaYukle]);

  const alinanToplam = odemeler.reduce((s, o) => s + (o.tutar || 0) * (o.kurDegeri || 1), 0);
  const adisyonToplam = adisyonlar.reduce((s, a) => s + a.toplamTutar, 0);
  const adisyonOdenenToplam = adisyonlar.filter(a => !a.isBuklet && a.odenenTutar > 0).reduce((s, a) => s + a.odenenTutar, 0);
  const rezKurDegeri = rez?.kurDegeri || 1;
  const etkinOdaTutariTL = (() => {
    let t = (rez?.odaTutari || 0) * rezKurDegeri;
    if (!rez?.cikisTarihi && rez?.girisTarihi && rez?.fiyatTipi === 'Gecelik ücret') {
      const giris = new Date(rez.girisTarihi);
      const bugun = new Date();
      const gece = Math.floor((Date.UTC(bugun.getFullYear(), bugun.getMonth(), bugun.getDate()) - Date.UTC(giris.getFullYear(), giris.getMonth(), giris.getDate())) / 86400000);
      if (gece > 0) t = t * gece;
    }
    return t;
  })();
  const kalanBakiye = Math.max(0, etkinOdaTutariTL + adisyonToplam - alinanToplam);

  async function handleAdisyonEkle() {
    if (!adForm.stokAdi.trim()) { alert('Ürün adı zorunludur.'); return; }
    if (parseFloat(adForm.birimFiyat) <= 0) { alert('Birim fiyat giriniz.'); return; }
    setAdKaydediliyor(true);
    try {
      await apiRequest('adisyonlar', 'POST', {
        stokId: adForm.stokId || null,
        stokAdi: adForm.stokAdi,
        miktar: parseFloat(adForm.miktar) || 1,
        birimFiyat: parseFloat(adForm.birimFiyat) || 0,
        iskonto: parseFloat(adForm.iskonto) || 0,
        not: adForm.not,
        rezervasyonId,
        personelId: personel?.personelId || 1,
      });
      setAdForm({ stokId: null, stokAdi: '', miktar: 1, birimFiyat: 0, iskonto: 0, not: '' });
      setStokArama('');
      await veriYukle();
      onGuncelle?.();
    } catch (e) { alert(e?.message || 'Adisyon eklenemedi.'); }
    setAdKaydediliyor(false);
  }

  async function handleLogEkle() {
    if (!logMesaj.trim()) { alert('Log mesajı boş olamaz.'); return; }
    setLogKaydediliyor(true);
    try {
      await apiRequest('rezervasyon-loglari', 'POST', {
        mesaj: logMesaj.trim(),
        tip: logTip,
        rezervasyonId,
        personelId: personel?.personelId || 1,
      });
      setLogMesaj('');
      await veriYukle();
      onGuncelle?.();
    } catch (e) { alert(e?.message || 'Log eklenemedi.'); }
    setLogKaydediliyor(false);
  }

  async function handleCheckIn() {
    try {
      await apiRequest(`rezervasyonlar/${rezervasyonId}/check-in`, 'PATCH');
      await veriYukle();
      onGuncelle?.();
    } catch (e) { alert(e?.message || 'Check-IN başarısız.'); }
  }

  async function handleSil() {
    if (!window.confirm('Rezervasyonu silmek istediğinize emin misiniz?')) return;
    try {
      await apiRequest(`rezervasyonlar/${rezervasyonId}`, 'DELETE');
      onGuncelle?.();
      onClose();
    } catch (e) { alert(e?.message || 'Silme başarısız.'); }
  }

  async function handleIptal() {
    if (!window.confirm('Rezervasyonu iptal etmek istediğinize emin misiniz?')) return;
    try {
      await apiRequest(`rezervasyonlar/${rezervasyonId}/iptal`, 'PATCH');
      await veriYukle();
      onGuncelle?.();
    } catch (e) { alert(e?.message || 'İptal başarısız.'); }
  }

  async function handleMisafirSil(misafirId) {
    if (!window.confirm('Misafiri bu rezervasyondan çıkarmak istediğinize emin misiniz?')) return;
    try {
      await apiRequest(`rezervasyonlar/${rezervasyonId}/misafir/${misafirId}`, 'DELETE');
      setMisafirDropdownAcik(false);
      await veriYukle();
    } catch (e) { alert(e?.message || 'Misafir silinemedi.'); }
  }

  async function handleRezKaydet() {
    setKaydediliyor(true);
    try {
      const parseTarih = (str) => {
        if (!str) return null;
        const [g, a, y] = str.split('.').map(Number);
        return new Date(Date.UTC(y, a - 1, g)).toISOString();
      };
      await apiRequest('rezervasyonlar', 'PUT', {
        rezervasyonId,
        ...rez,
        girisTarihi: parseTarih(rezForm.girisTarihi),
        cikisTarihi: rezForm.cikisBelir ? null : parseTarih(rezForm.cikisTarihi),
        girisSaati: rezForm.girisSaati,
        cikisSaati: rezForm.cikisSaati,
        not: rezForm.not,
        renkEtiketi: rezForm.renkEtiketi,
        odaCheckInYapildi: rezForm.odaCheckInYapildi,
        otomatikUzatmaAktif: rezForm.otomatikUzatmaAktif,
        belirsizCikisKilitGun: rezForm.cikisBelir && rezForm.belirsizKilit ? parseInt(rezForm.belirsizKilitGun) || null : null,
        odaTutari: parseFloat(rezForm.odaTutari) || 0,
        fiyatTipi: rezForm.fiyatTipi,
        kisiSayisi: rezForm.kisiSayisi || 1,
        paraBirimi: rezForm.paraBirimi || 'TL',
        kurDegeri: rezForm.kurDegeri || 1,
        misafirler: [],
      });
      await veriYukle();
      onGuncelle?.();
    } catch (e) { alert(e?.message || 'Kayıt başarısız.'); }
    setKaydediliyor(false);
  }

  if (yukleniyor) return (
    <div className="fixed inset-0 z-[10000] flex items-center justify-center"
      style={{ backdropFilter: 'blur(12px)', background: 'rgba(15,23,42,0.65)' }}>
      <div className="bg-white/95 rounded-[2rem] p-8 text-center shadow-2xl border border-white/20">
        <div className="w-12 h-12 border-4 border-indigo-200 border-t-indigo-600 rounded-full animate-spin mx-auto mb-4"></div>
        <p className="text-slate-500 text-[10px] font-black uppercase tracking-widest">Rezervasyon yükleniyor...</p>
      </div>
    </div>
  );

  if (!rez) return null;

  const readonly = rez.durum?.includes('C-OUT') || rez.durum?.includes('İptal');

  const misafirler = rez.rezervasyonMisafirler || [];
  const ilkMisafir = misafirler[0]?.misafir?.adSoyad || '—';
  const gece = (() => {
    if (rezForm.cikisBelir || !rezForm.cikisTarihi) return null;
    try {
      const [g1, a1, y1] = rezForm.girisTarihi.split('.').map(Number);
      const [g2, a2, y2] = rezForm.cikisTarihi.split('.').map(Number);
      return Math.max(0, Math.round((new Date(y2, a2 - 1, g2) - new Date(y1, a1 - 1, g1)) / 86400000));
    } catch { return null; }
  })();

  const tabIkonlar = { 'Rezervasyon': '🏨', 'Ödemeler': '💳', 'Adisyonlar': '🧾', 'E-fatura': '📄', 'Evraklar': '📁', 'Log': '📋' };

  return createPortal(
    <>
      <div className="fixed inset-0 z-[10000] flex items-center justify-center p-0 md:p-4"
        style={{ backdropFilter: 'blur(12px)', background: 'rgba(15,23,42,0.65)' }}>
        <div className="bg-slate-50 rounded-none md:rounded-[2.5rem] shadow-2xl w-full max-w-6xl h-screen md:h-auto md:max-h-[95vh] overflow-hidden flex flex-col"
          style={{ animation: 'fadeIn 0.2s ease-out' }}>

          {/* ── MODAL HEADER ── */}
          <div className="bg-gradient-to-r from-slate-900 via-slate-800 to-indigo-900 px-4 py-3 md:px-6 md:py-4 flex items-center gap-4 flex-shrink-0">
            <div className="flex-1 min-w-0">
              <div className="flex items-center gap-3 flex-wrap">
                <span className="text-white font-black text-lg truncate">{ilkMisafir}</span>
                {misafirler.length > 1 && (
                  <span className="text-slate-400 text-xs font-black uppercase tracking-widest">+{misafirler.length - 1} misafir</span>
                )}
                <span className={`text-[10px] font-black uppercase tracking-widest px-3 py-1 rounded-full ${durumRenk(rez.durum)}`}>{rez.durum}</span>
              </div>
              <div className="flex items-center gap-4 mt-1 text-slate-400 text-xs flex-wrap">
                <span>Oda {rez.odaNo}{rez.odaTipiAd ? ` · ${rez.odaTipiAd}` : ''}</span>
                <span>·</span>
                <span>{rezForm.girisTarihi} → {rezForm.cikisBelir ? <span className="text-amber-400 italic">Belirsiz</span> : rezForm.cikisTarihi}</span>
                <span>·</span>
                <span>{gece !== null ? `${gece} gece` : 'Gece belirsiz'}</span>
                <span className="font-mono text-indigo-300">#{rez.rezNo}</span>
              </div>
              {rez.not && (
                <div className="flex items-center gap-1.5 mt-1">
                  <span className="text-slate-400 text-xs">📝</span>
                  <span className="text-slate-300 text-xs truncate max-w-sm">{rez.not}</span>
                </div>
              )}
            </div>
            <button onClick={onClose}
              className="w-9 h-9 bg-white/10 hover:bg-white/20 rounded-2xl flex items-center justify-center text-white font-black transition-colors flex-shrink-0">✕</button>
          </div>

          {/* ── TAB BAR ── */}
          <div className="bg-white border-b border-slate-100 flex items-center gap-1.5 px-4 py-2.5 flex-shrink-0 overflow-x-auto">
            {tabs.map(tab => (
              <button key={tab} onClick={() => setAktifTab(tab)}
                className={`px-3.5 py-1.5 text-[10px] font-black uppercase tracking-widest transition-all whitespace-nowrap flex items-center gap-1.5 rounded-2xl
                  ${aktifTab === tab
                    ? 'bg-gradient-to-r from-indigo-600 to-violet-600 text-white shadow-md'
                    : 'text-slate-400 hover:text-indigo-600 hover:bg-indigo-50'}`}>
                <span className="text-sm">{tabIkonlar[tab]}</span>
                {tab}
              </button>
            ))}
          </div>

          {/* ── READONLY BANNER ── */}
          {readonly && (
            <div className="bg-slate-50 border-b border-slate-200 px-5 py-2 flex items-center gap-2 text-slate-500 text-[10px] font-black uppercase tracking-widest flex-shrink-0">
              <span>🔒</span>
              Bu rezervasyon tamamlanmış veya iptal edilmiştir — düzenleme ve işlem yapılamaz.
            </div>
          )}

          {/* ── TAB CONTENT ── */}
          <div className="flex-1 overflow-y-auto pb-6">
            {/* Global Eksik Buklet Uyarısı */}
            {eksikBukletLoglari.length > 0 && (
              <div className="px-3 md:px-6 pt-4">
                <div className="bg-amber-50 border border-amber-200 rounded-2xl px-4 py-3 text-sm text-amber-800 flex items-start gap-3 shadow-sm">
                  <span className="text-lg leading-none mt-0.5">⚠️</span>
                  <div className="flex-1">
                    <p className="font-bold mb-0.5">Eksik Buklet Malzemesi</p>
                    <ul className="list-disc list-inside opacity-90 space-y-0.5">
                      {eksikBukletLoglari.map((l, idx) => (
                        <li key={idx} className="text-xs">{l.mesaj.replace('⚠️ STOK YETERSİZ: ', '')}</li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>
            )}

            {/* ── TAB 1: REZERVASYON ── */}
            {aktifTab === 'Rezervasyon' && (
              <div className="flex flex-col md:flex-row gap-0 md:h-full" style={{ animation: 'slideIn 0.2s ease-out' }}>
                {/* Sol panel */}
                <div className="w-full md:w-72 md:flex-shrink-0 bg-white border-b md:border-b-0 md:border-r border-slate-200 p-5 space-y-4 overflow-y-auto">
                  <div className="flex items-center gap-2">
                    <span className="w-6 h-6 bg-gradient-to-br from-indigo-500 to-violet-500 text-white rounded-xl flex items-center justify-center text-xs font-black">1</span>
                    <span className="text-[10px] font-black uppercase tracking-widest text-slate-400">Rezervasyon Bilgileri</span>
                  </div>

                  <div><label className={labelClass}>Giriş Tarihi</label>
                    <DatePicker value={rezForm.girisTarihi} onChange={v => setRezForm(p => ({ ...p, girisTarihi: v }))} />
                  </div>
                  <div className="grid grid-cols-2 gap-2">
                    <div><label className={labelClass}>Giriş Saati</label>
                      <input type="time" value={rezForm.girisSaati} onChange={e => setRezForm(p => ({ ...p, girisSaati: e.target.value }))} className={inputClass} />
                    </div>
                    <div><label className={labelClass}>Gece</label>
                      <input type="text" value={gece !== null ? gece : 'Belirsiz'} readOnly className={inputClass + ' bg-slate-100'} />
                    </div>
                  </div>
                  <div>
                    <label className={labelClass}>Çıkış Tarihi</label>
                    <div className="flex items-center gap-2">
                      <div className={`flex-1 ${rezForm.cikisBelir ? 'opacity-40 pointer-events-none' : ''}`}>
                        <DatePicker value={rezForm.cikisTarihi} onChange={v => setRezForm(p => ({ ...p, cikisTarihi: v }))} minDate={rezForm.girisTarihi} />
                      </div>
                      <label className="flex items-center gap-1.5 cursor-pointer whitespace-nowrap">
                        <input type="checkbox" checked={rezForm.cikisBelir || false} onChange={async e => {
                          const belirsiz = e.target.checked;
                          if (!belirsiz) {
                            setRezForm(p => ({ ...p, cikisBelir: false, fiyatTipi: 'Toplam fiyat' }));
                            setOtomatikFiyat(null);
                            return;
                          }
                          const misafirTipiFiyat = rez?.misafirTipiId && rez?.misafirTipiGecelikFiyat > 0
                            ? rez.misafirTipiGecelikFiyat : null;
                          const gecelikSonuc = misafirTipiFiyat != null
                            ? { fiyat: misafirTipiFiyat, pb: rez?.paraBirimi || 'TRY' }
                            : await gecelikFiyatHesapla(rezForm.girisTarihi);
                          setRezForm(p => ({
                            ...p,
                            cikisBelir: true,
                            cikisTarihi: '',
                            fiyatTipi: 'Gecelik ücret',
                            ...(gecelikSonuc != null ? { odaTutari: gecelikSonuc.fiyat } : {}),
                          }));
                          if (gecelikSonuc != null) {
                            setOtomatikFiyat({ toplam: gecelikSonuc.fiyat, gece: null, pb: gecelikSonuc.pb, pansiyonEk: 0, kisiBasiMevcut: false, kisiBasiHesap: null });
                          }
                        }} className="w-4 h-4 accent-indigo-600" />
                        <span className="text-xs text-slate-500">Belirsiz</span>
                      </label>
                    </div>
                    {rezForm.cikisBelir && (
                      <div className="mt-2 flex items-center gap-2 bg-amber-50 border border-amber-200 rounded-xl px-3 py-2">
                        <input type="checkbox" id="detayBelirsizKilitCb" checked={rezForm.belirsizKilit || false} onChange={e => setRezForm(p => ({ ...p, belirsizKilit: e.target.checked }))} className="w-4 h-4 flex-shrink-0" />
                        <label htmlFor="detayBelirsizKilitCb" className="text-xs text-amber-700 cursor-pointer whitespace-nowrap">Odayı kilitle</label>
                        <input
                          type="number" min="1" max="365"
                          value={rezForm.belirsizKilitGun || 30}
                          onChange={e => setRezForm(p => ({ ...p, belirsizKilitGun: e.target.value }))}
                          disabled={!rezForm.belirsizKilit}
                          className={`w-16 text-center text-xs border rounded-xl px-2 py-1 ${rezForm.belirsizKilit ? 'border-amber-300 bg-white text-amber-800' : 'border-slate-200 bg-slate-50 text-slate-300'}`}
                        />
                        <span className={`text-xs ${rezForm.belirsizKilit ? 'text-amber-700' : 'text-slate-400'}`}>gün</span>
                      </div>
                    )}
                  </div>
                  <div><label className={labelClass}>Çıkış Saati</label>
                    <input type="time" value={rezForm.cikisSaati} onChange={e => setRezForm(p => ({ ...p, cikisSaati: e.target.value }))} className={inputClass} disabled={rezForm.cikisBelir} />
                  </div>
                  <div><label className={labelClass}>Acente / Firma</label>
                    <input value={rez.firmaAd || rez.acenteAd || '—'} readOnly className={inputClass + ' bg-slate-100'} />
                  </div>
                  <div><label className={labelClass}>Oda</label>
                    <input value={`Oda ${rez.odaNo}${rez.odaTipiAd ? ` - ${rez.odaTipiAd}` : ''}`} readOnly className={inputClass + ' bg-slate-100'} />
                  </div>
                  <div className="grid grid-cols-2 gap-3">
                    <div><label className={labelClass}>Oda Check-IN</label>
                      <label className="flex items-center gap-2 mt-2.5 cursor-pointer">
                        <input type="checkbox" checked={rezForm.odaCheckInYapildi} onChange={e => setRezForm(p => ({ ...p, odaCheckInYapildi: e.target.checked }))}
                          className="w-4 h-4 accent-indigo-600" />
                        <span className="text-sm text-slate-600">Yapıldı</span>
                      </label>
                    </div>
                  </div>
                  <div><label className={labelClass}>Not / Açıklama</label>
                    <textarea rows={2} value={rezForm.not} onChange={e => setRezForm(p => ({ ...p, not: e.target.value }))} className={`${inputClass} resize-none`} />
                  </div>
                  <div className="flex items-center gap-3">
                    <label className="flex items-center gap-2 cursor-pointer">
                      <input type="checkbox" checked={rezForm.otomatikUzatmaAktif} onChange={e => setRezForm(p => ({ ...p, otomatikUzatmaAktif: e.target.checked }))}
                        className="w-4 h-4 accent-indigo-600" />
                      <span className="text-xs text-slate-500">Otomatik uzatma aktif</span>
                    </label>
                    {rezForm.otomatikUzatmaAktif && rez?.rezervasyonId && (
                      <button
                        type="button"
                        onClick={() => setUzatmaModal('onay')}
                        className="text-xs bg-teal-50 hover:bg-teal-100 text-teal-700 border border-teal-200 px-2.5 py-1 rounded-lg font-medium transition-colors"
                      >
                        🔄 Şimdi Uzat
                      </button>
                    )}
                  </div>
                  <div className="flex gap-2 pt-3 border-t border-slate-100">
                    <button onClick={handleSil}
                      className="flex-1 bg-red-600 hover:bg-red-700 text-white px-3 py-2 rounded-2xl text-[10px] font-black uppercase tracking-widest transition-colors">
                      Sil
                    </button>
                    <button onClick={handleIptal}
                      className="flex-1 bg-orange-500 hover:bg-orange-600 text-white px-3 py-2 rounded-2xl text-[10px] font-black uppercase tracking-widest transition-colors">
                      İptal Et
                    </button>
                  </div>
                </div>

                {/* Sağ panel */}
                <div className="flex-1 p-3 md:p-5 space-y-4 overflow-y-auto">
                  {/* Misafirler */}
                  <div className="bg-white rounded-2xl border border-slate-100 shadow-sm overflow-hidden">
                    <div className="bg-gradient-to-r from-slate-50 to-indigo-50/30 border-b border-slate-100 px-5 py-3 flex items-center justify-between">
                      <div className="flex items-center gap-2">
                        <span className="w-5 h-5 bg-gradient-to-br from-indigo-500 to-violet-500 text-white rounded-xl flex items-center justify-center text-xs font-black">2</span>
                        <span className="text-[10px] font-black uppercase tracking-widest text-slate-400">Misafirler</span>
                      </div>
                      <div className="flex items-center gap-2">
                        <span className="text-slate-400 text-[10px] font-black uppercase tracking-widest">{misafirler.length} kişi</span>
                        {!readonly && (
                          <button
                            onClick={() => setMisafirEkleAcik(true)}
                            className="bg-indigo-600 hover:bg-indigo-700 text-white text-[10px] font-black px-3 py-1 rounded-lg uppercase tracking-widest transition-colors"
                          >
                            + Ekle
                          </button>
                        )}
                      </div>
                    </div>
                    <div className="overflow-x-auto">
                      {misafirler.length > 0 ? (
                        <DataTable
                          satirlar={misafirler}
                          bosIkon="👤"
                          bosMetin="Misafir kaydı yok"
                          yogun
                          kolonlar={[
                            {
                              anahtar: 'tc', baslik: 'T.C / Pas. No',
                              deger: rm => rm.misafir?.tcPasaportNo || rm.misafir?.pasaportNo || '',
                              ciz: rm => (
                                <span className="font-mono text-slate-500">
                                  {rm.misafir?.tcPasaportNo || rm.misafir?.pasaportNo || '—'}
                                </span>
                              ),
                            },
                            {
                              anahtar: 'adSoyad', baslik: 'Ad Soyad', siralanir: true,
                              deger: rm => rm.misafir?.adSoyad || '',
                              ciz: rm => <span className="font-semibold text-slate-800">{rm.misafir?.adSoyad}</span>,
                            },
                            {
                              anahtar: 'grupTip', baslik: 'Tip', hizala: 'orta',
                              ciz: rm => (
                                <Rozet renk={rm.grupTip === 'Çocuk' ? 'amber' : 'indigo'}>
                                  {rm.grupTip === 'Çocuk' ? '🧒 Çocuk' : '👤 Yetişkin'}
                                </Rozet>
                              ),
                            },
                            {
                              anahtar: 'dogumTarihi', baslik: 'Doğum Tarihi',
                              deger: rm => rm.misafir?.dogumTarihi || '',
                              ciz: rm => (
                                <span className="text-slate-500 whitespace-nowrap">
                                  {rm.misafir?.dogumTarihi ? fmt(rm.misafir.dogumTarihi) : '—'}
                                </span>
                              ),
                            },
                            {
                              anahtar: 'ulke', baslik: 'Ülke',
                              deger: rm => rm.misafir?.ulke || '',
                              ciz: rm => <span className="text-slate-500">{rm.misafir?.ulke || 'TÜRKİYE'}</span>,
                            },
                            {
                              anahtar: 'telefon', baslik: 'Telefon',
                              deger: rm => rm.misafir?.telefon || '',
                              ciz: rm => <span className="text-slate-500">{rm.misafir?.telefon || '—'}</span>,
                            },
                            {
                              anahtar: 'cinsiyet', baslik: 'Cinsiyet', hizala: 'orta',
                              deger: rm => rm.misafir?.cinsiyet || '',
                              ciz: rm => rm.misafir?.cinsiyet
                                ? <Rozet renk={rm.misafir.cinsiyet === 'Erkek' ? 'indigo' : 'rose'}>{rm.misafir.cinsiyet}</Rozet>
                                : null,
                            },
                            {
                              anahtar: 'islem', baslik: 'İşlem', hizala: 'sag',
                              ciz: (rm, i) => (
                                <div className="relative inline-block">
                                  <button onClick={(e) => {
                                    e.stopPropagation();
                                    if (misafirDropdownAcik === i) { setMisafirDropdownAcik(false); }
                                    else {
                                      const rect = e.currentTarget.getBoundingClientRect();
                                      setMisafirDropdownPos({ top: rect.bottom + 4, left: rect.left });
                                      setMisafirDropdownAcik(i);
                                    }
                                  }} className="bg-indigo-600 hover:bg-indigo-700 text-white text-xs px-3 py-1 rounded-lg font-semibold transition-colors">
                                    İşlem ▾
                                  </button>
                                  {misafirDropdownAcik === i && (
                                    <>
                                      <div className="fixed inset-0 z-[65]" onClick={() => setMisafirDropdownAcik(false)} />
                                      <div className="fixed bg-white border border-slate-200 rounded-xl shadow-xl py-1 z-[70] w-44"
                                        style={{ top: misafirDropdownPos.top, left: Math.min(misafirDropdownPos.left, window.innerWidth - 180) }}>
                                        <button onClick={() => { setMisafirDropdownAcik(false); setMisafirDuzenle(rm.misafir); }}
                                          className="w-full text-left px-4 py-2 text-sm text-slate-700 hover:bg-indigo-50 hover:text-indigo-700 transition-colors flex items-center gap-2">
                                          <span>✏️</span> Düzenle
                                        </button>
                                        <button onClick={() => handleMisafirSil(rm.misafir.misafirId)}
                                          className="w-full text-left px-4 py-2 text-sm text-red-600 hover:bg-red-50 transition-colors flex items-center gap-2">
                                          <span>🗑️</span> Sil
                                        </button>
                                      </div>
                                    </>
                                  )}
                                </div>
                              ),
                            },
                          ]}
                        />
                      ) : (
                        <div className="py-8 text-center text-slate-400 text-sm">Misafir kaydı bulunamadı</div>
                      )}
                    </div>
                  </div>

                  {/* Fiyat + Hesap Özeti */}
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <div className="bg-white rounded-2xl border border-slate-100 shadow-sm overflow-hidden">
                      <div className="bg-gradient-to-r from-slate-50 to-indigo-50/30 border-b border-slate-100 px-5 py-3 flex items-center gap-2">
                        <span className="w-5 h-5 bg-gradient-to-br from-indigo-500 to-violet-500 text-white rounded-xl flex items-center justify-center text-xs font-black">3</span>
                        <span className="text-[10px] font-black uppercase tracking-widest text-slate-400">Fiyat Bilgileri</span>
                      </div>
                      <div className="p-4 space-y-3">
                        {fiyatYukleniyor && (
                          <div className="bg-indigo-50 border border-indigo-100 rounded-xl px-3 py-2 text-xs text-indigo-500 animate-pulse">
                            Fiyat hesaplanıyor...
                          </div>
                        )}
                        {otomatikFiyat && !fiyatYukleniyor && (() => {
                          const carpanKurallar = otomatikFiyat.carpanMesaj
                            ? [...new Set(otomatikFiyat.carpanMesaj.split(' + ').map(s => s.trim()).filter(Boolean))]
                            : [];
                          return (
                            <div className="bg-emerald-50 border border-emerald-200 rounded-xl px-3 py-2 text-xs text-emerald-700 space-y-1">
                              {carpanKurallar.length > 0 && (
                                <div className="bg-orange-50 border border-orange-200 rounded-lg px-2 py-1.5 text-orange-700 mb-1.5">
                                  <p className="font-bold mb-0.5">🔥 Yoğun Dönem Fiyatı</p>
                                  {carpanKurallar.map((k, i) => <p key={i} className="opacity-90">{k}</p>)}
                                </div>
                              )}
                              <div>{otomatikFiyat.gece === null ? '✓ Gecelik ücret:' : '✓ Günlük hesap:'} <strong>{(otomatikFiyat.toplam || 0).toLocaleString('tr-TR')} {otomatikFiyat.pb || 'TRY'}</strong>{otomatikFiyat.gece !== null && <span> ({otomatikFiyat.gece} gece)</span>}
                                {otomatikFiyat.pansiyonEk > 0 && <span className="text-emerald-600 ml-1">(+{otomatikFiyat.pansiyonEk.toLocaleString('tr-TR')} {otomatikFiyat.pb || 'TRY'}/gece {rez.pansiyonTipiAd})</span>}
                                <button onClick={() => setRezForm(p => ({ ...p, fiyatTipi: otomatikFiyat.gece === null ? 'Gecelik ücret' : 'Toplam fiyat', odaTutari: otomatikFiyat.toplam }))}
                                  className="ml-2 underline text-emerald-600 hover:text-emerald-800">uygula</button>
                              </div>
                              {otomatikFiyat.kisiBasiMevcut && otomatikFiyat.kisiBasiHesap && (
                                <div>👤 Kişi bazlı ({otomatikFiyat.kisiBasiHesap.kisiSayisi} kişi): <strong>{(otomatikFiyat.kisiBasiHesap.toplam || 0).toLocaleString('tr-TR')} {otomatikFiyat.pb || 'TRY'}</strong>
                                  {otomatikFiyat.pansiyonEk > 0 && <span className="text-emerald-600 ml-1">(pansiyon dahil)</span>}
                                  <button onClick={() => setRezForm(p => ({ ...p, fiyatTipi: 'Kişi bazlı fiyat', odaTutari: otomatikFiyat.kisiBasiHesap.toplam }))}
                                    className="ml-2 underline text-emerald-600 hover:text-emerald-800">uygula</button>
                                </div>
                              )}
                            </div>
                          );
                        })()}
                        {rez.fiyatTipi === 'Gecelik ücret' && (
                          <div className="bg-amber-50 border border-amber-200 rounded-xl px-3 py-2 text-xs text-amber-700">
                            Çıkış tarihi belirsiz — gecelik ücret üzerinden fatura edilecek. Toplam check-out sırasında hesaplanacak.
                          </div>
                        )}
                        <div className="flex gap-2">
                          <div className="flex-1">
                            <label className={labelClass}>
                              {rez.fiyatTipi === 'Gecelik ücret' ? 'Gecelik Ücret'
                                : rez.fiyatTipi === 'Kişi bazlı fiyat' ? 'Kişi Bazlı Tutar'
                                  : 'Toplam Tutar'}
                            </label>
                            <input type="number" value={rezForm.odaTutari} onChange={e => setRezForm(p => ({ ...p, odaTutari: e.target.value }))} className={inputClass} />
                          </div>
                          <div className="w-12 flex items-end pb-2.5"><span className="text-sm font-semibold text-slate-400">TL</span></div>
                        </div>
                        <p className="text-xs text-slate-500">Personel: <strong className="text-slate-700">{rez.personelAd}</strong></p>
                        <div className="flex gap-2 pt-1">
                          {!readonly && (
                            <button onClick={() => setPopup('odeme')}
                              className="flex-1 bg-gradient-to-r from-indigo-600 to-violet-600 hover:from-indigo-700 hover:to-violet-700 text-white text-[10px] font-black uppercase tracking-widest py-2 rounded-2xl transition-all shadow-sm">
                              Ödeme Al
                            </button>
                          )}
                          {!readonly && !rez.durum?.includes('C-IN') && (
                            <button onClick={handleCheckIn}
                              className="flex-1 bg-emerald-600 hover:bg-emerald-700 text-white text-[10px] font-black uppercase tracking-widest py-2 rounded-2xl transition-colors">
                              Check IN
                            </button>
                          )}
                          {!readonly && rez.durum?.includes('C-IN') && (
                            <button onClick={() => setPopup('checkout')}
                              className="flex-1 bg-orange-500 hover:bg-orange-600 text-white text-[10px] font-black uppercase tracking-widest py-2 rounded-2xl transition-colors">
                              Check OUT
                            </button>
                          )}
                        </div>
                      </div>
                    </div>

                    {/* Hesap özeti */}
                    <div className="bg-white rounded-2xl border border-slate-100 shadow-sm overflow-hidden">
                      <div className="bg-gradient-to-r from-slate-50 to-indigo-50/30 border-b border-slate-100 px-5 py-3 flex items-center gap-2">
                        <span className="w-5 h-5 bg-gradient-to-br from-indigo-500 to-violet-500 text-white rounded-xl flex items-center justify-center text-xs font-black">4</span>
                        <span className="text-[10px] font-black uppercase tracking-widest text-slate-400">Hesap Özeti</span>
                      </div>
                      <div className="p-4 space-y-2">
                        {rez.fiyatTipi === 'Gecelik ücret' ? (
                          <>
                            {[
                              { label: 'Gecelik ücret', value: (rez.odaTutari || 0).toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 4 }) + ' ' + (rez.paraBirimi || 'TL') + ' / gece' + (rez.paraBirimi && rez.paraBirimi !== 'TL' && rez.paraBirimi !== 'TRY' ? ' (≈ ' + etkinOdaTutariTL.toLocaleString('tr-TR', { minimumFractionDigits: 0 }) + ' ₺)' : ''), cls: 'text-amber-600 font-semibold' },
                              { label: 'Adisyon tutarı', value: adisyonToplam.toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 4 }) + ' ₺', cls: 'text-amber-600' },
                              { label: 'Oda tutarı', value: 'Check-out\'ta hesaplanacak', cls: 'text-slate-400 italic', sep: true },
                              { label: 'Alınan ödemeler', value: alinanToplam.toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 4 }) + ' ₺', cls: 'text-emerald-600 font-semibold' },
                              ...(adisyonOdenenToplam > 0 ? [{ label: '  └ Adisyon ödemeleri', value: adisyonOdenenToplam.toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 4 }) + ' ₺', cls: 'text-emerald-500 text-xs' }] : []),
                            ].map(item => (
                              <div key={item.label} className={`flex items-center justify-between py-1.5 ${item.sep ? 'border-t border-slate-100 pt-2.5 mt-1' : ''}`}>
                                <span className="text-xs text-slate-500">{item.label}</span>
                                <span className={`text-sm ${item.cls}`}>{item.value}</span>
                              </div>
                            ))}
                            <div className="bg-amber-50 border border-amber-200 rounded-xl px-3 py-2 text-xs text-amber-700 text-center font-semibold mt-2">
                              Check-OUT sırasında toplam otomatik hesaplanacak
                            </div>
                          </>
                        ) : (
                          <>
                            {[
                              { label: rez.fiyatTipi === 'Kişi bazlı fiyat' ? 'Oda tutarı (kişi bazlı)' : 'Oda tutarı', value: (rez.odaTutari || 0).toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 4 }) + ' ' + (rez.paraBirimi || 'TL') + (rez.paraBirimi && rez.paraBirimi !== 'TL' && rez.paraBirimi !== 'TRY' ? ' (≈ ' + etkinOdaTutariTL.toLocaleString('tr-TR', { minimumFractionDigits: 0 }) + ' ₺)' : ''), cls: 'text-slate-700' },
                              { label: 'Adisyon tutarı', value: adisyonToplam.toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 4 }) + ' ₺', cls: 'text-amber-600' },
                              { label: 'Toplam tutar', value: (etkinOdaTutariTL + adisyonToplam).toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 4 }) + ' ₺', cls: 'text-slate-800 font-bold', sep: true },
                              { label: 'Alınan ödemeler', value: alinanToplam.toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 4 }) + ' ₺', cls: 'text-emerald-600 font-semibold' },
                              ...(adisyonOdenenToplam > 0 ? [{ label: '  └ Adisyon ödemeleri', value: adisyonOdenenToplam.toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 4 }) + ' ₺', cls: 'text-emerald-500 text-xs' }] : []),
                              { label: 'Kalan bakiye', value: kalanBakiye.toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 4 }) + ' ₺', cls: kalanBakiye > 0 ? 'text-red-600 font-bold' : 'text-emerald-600 font-bold', sep: true },
                            ].map(item => (
                              <div key={item.label} className={`flex items-center justify-between py-1.5 ${item.sep ? 'border-t border-slate-100 pt-2.5 mt-1' : ''}`}>
                                <span className="text-xs text-slate-500">{item.label}</span>
                                <span className={`text-sm ${item.cls}`}>{item.value}</span>
                              </div>
                            ))}
                          </>
                        )}
                      </div>

                      {/* Vergi dökümü — beyan ve fatura için matrahın görünmesi gerekiyor */}
                      {vergiDokumu && vergiDokumu.matrah > 0 && (
                        <div className="mx-4 mb-4 bg-violet-50/60 border border-violet-100 rounded-xl px-3 py-2.5">
                          <p className="text-[10px] font-black uppercase tracking-widest text-violet-500 mb-1.5">
                            {rez.fiyatTipi === 'Gecelik ücret' ? 'Gecelik ücretin vergi dökümü' : 'Oda tutarının vergi dökümü'}
                          </p>
                          <div className="space-y-1">
                            <div className="flex justify-between text-[11px]">
                              <span className="text-slate-500">Matrah (vergi hariç)</span>
                              <span className="font-semibold text-slate-700">
                                {vergiDokumu.matrah.toLocaleString('tr-TR', { minimumFractionDigits: 2 })} ₺
                              </span>
                            </div>
                            <div className="flex justify-between text-[11px]">
                              <span className="text-slate-500">KDV %{vergiDokumu.kdvOrani}</span>
                              <span className="font-semibold text-slate-700">
                                {vergiDokumu.kdvTutari.toLocaleString('tr-TR', { minimumFractionDigits: 2 })} ₺
                              </span>
                            </div>
                            <div className="flex justify-between text-[11px]">
                              <span className="text-slate-500">Konaklama vergisi %{vergiDokumu.konaklamaVergisiOrani}</span>
                              <span className="font-semibold text-slate-700">
                                {vergiDokumu.konaklamaVergisiTutari.toLocaleString('tr-TR', { minimumFractionDigits: 2 })} ₺
                              </span>
                            </div>
                          </div>
                        </div>
                      )}

                      {rez.fiyatTipi !== 'Gecelik ücret' && kalanBakiye === 0 && (
                        <div className="mx-4 mb-4 bg-emerald-50 border border-emerald-200 rounded-xl px-3 py-2 text-xs text-emerald-700 text-center font-semibold">
                          ✅ Hesap kapatılmış
                        </div>
                      )}
                      {rez.fiyatTipi !== 'Gecelik ücret' && kalanBakiye > 0 && (
                        <div className="mx-4 mb-4 bg-red-50 border border-red-200 rounded-xl px-3 py-2 text-xs text-red-700 text-center font-semibold">
                          ⚠️ Ödeme bekliyor
                        </div>
                      )}
                    </div>
                  </div>

                  {!readonly && (
                    <div className="flex justify-end">
                      <button onClick={handleRezKaydet} disabled={kaydediliyor}
                        className="bg-gradient-to-r from-indigo-600 to-violet-600 hover:from-indigo-700 hover:to-violet-700 disabled:opacity-60 text-white px-6 py-2.5 rounded-2xl text-[10px] font-black uppercase tracking-widest shadow-md transition-all">
                        {kaydediliyor ? '⏳ Kaydediliyor...' : '💾 Değişiklikleri Kaydet'}
                      </button>
                    </div>
                  )}
                </div>
              </div>
            )}

            {/* ── TAB 2: ÖDEMELER ── */}
            {aktifTab === 'Ödemeler' && (
              <div className="p-3 md:p-6 space-y-4" style={{ animation: 'slideIn 0.2s ease-out' }}>
                <div className="flex items-center justify-between flex-wrap gap-3">
                  <div className="flex gap-3 flex-wrap">
                    <div className="bg-white rounded-2xl border border-slate-100 shadow-sm px-4 py-3 text-center">
                      <p className="text-[10px] font-black uppercase tracking-widest text-slate-400 mb-1">Alınan Toplam</p>
                      <p className="text-lg font-black text-emerald-600">{alinanToplam.toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 4 })} ₺</p>
                    </div>
                    <div className="bg-white rounded-2xl border border-slate-100 shadow-sm px-4 py-3 text-center">
                      <p className="text-[10px] font-black uppercase tracking-widest text-slate-400 mb-1">Kalan Bakiye</p>
                      <p className={`text-lg font-black ${kalanBakiye > 0 ? 'text-red-600' : 'text-emerald-600'}`}>{kalanBakiye.toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 4 })} ₺</p>
                    </div>
                  </div>
                  {!readonly && (
                    <button onClick={() => setPopup('odeme')}
                      className="bg-gradient-to-r from-indigo-600 to-violet-600 hover:from-indigo-700 hover:to-violet-700 text-white px-5 py-2.5 rounded-2xl text-[10px] font-black uppercase tracking-widest shadow-md transition-all">
                      + Ödeme Ekle
                    </button>
                  )}
                </div>
                <div className="bg-white rounded-2xl border border-slate-100 shadow-sm overflow-x-auto">
                  <DataTable
                    anahtarAlan="odemeId"
                    satirlar={odemeler}
                    bosIkon="💳"
                    bosMetin="Ödeme kaydı bulunmuyor"
                    yogun
                    kolonlar={[
                      {
                        anahtar: 'aciklama', baslik: 'Açıklama', siralanir: true,
                        ciz: o => <span className="text-slate-700">{o.aciklama}</span>,
                      },
                      {
                        anahtar: 'tutar', baslik: 'Tutar', hizala: 'sag', siralanir: true,
                        ciz: o => (
                          <span className="font-bold text-slate-800 whitespace-nowrap">
                            {o.paraBirimi && o.paraBirimi !== 'TL' && o.paraBirimi !== 'TRY' ? (
                              <>
                                {o.tutar.toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 4 })} {o.paraBirimi}
                                <span className="text-xs font-normal text-slate-500">
                                  {' '}(≈{((o.tutar || 0) * (o.kurDegeri || 1)).toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 4 })} ₺)
                                </span>
                              </>
                            ) : (
                              <>{o.tutar.toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 4 })} ₺</>
                            )}
                          </span>
                        ),
                      },
                      {
                        anahtar: 'odemeTipi', baslik: 'Ödeme Tipi', hizala: 'orta', siralanir: true,
                        ciz: o => <Rozet renk="indigo">{o.odemeTipi}</Rozet>,
                      },
                      {
                        anahtar: 'bankaAdi', baslik: 'Banka', siralanir: true,
                        ciz: o => <span className="text-slate-500 text-xs">{o.bankaAdi || '—'}</span>,
                      },
                      {
                        anahtar: 'odemeTarihi', baslik: 'Tarih / Saat', siralanir: true,
                        ciz: o => (
                          <span className="text-slate-500 text-xs whitespace-nowrap">{fmt(o.odemeTarihi)} {o.odemeSaati}</span>
                        ),
                      },
                      {
                        anahtar: 'personelAd', baslik: 'Personel', siralanir: true,
                        ciz: o => <span className="text-slate-600 text-xs">{o.personelAd}</span>,
                      },
                      {
                        anahtar: 'islem', baslik: 'İşlem', hizala: 'sag',
                        ciz: o => !readonly && (
                          <button onClick={async () => {
                            if (!window.confirm('Ödeme silinsin mi?')) return;
                            await apiRequest(`odemeler/${o.odemeId}`, 'DELETE');
                            await veriYukle();
                          }} className="bg-red-50 hover:bg-red-100 text-red-600 text-xs px-3 py-1.5 rounded-lg font-semibold ring-1 ring-red-200 transition-colors">
                            Sil
                          </button>
                        ),
                      },
                    ]}
                  />
                </div>
              </div>
            )}

            {/* ── TAB 3: ADİSYONLAR ── */}
            {aktifTab === 'Adisyonlar' && (
              <div className="p-3 md:p-6 space-y-4" style={{ animation: 'slideIn 0.2s ease-out' }}>
                {!readonly && (
                  <div className="bg-white rounded-2xl border border-slate-100 shadow-sm p-5">
                    <div className="flex items-center gap-2 mb-4">
                      <span className="w-6 h-6 bg-gradient-to-br from-amber-400 to-orange-500 text-white rounded-xl flex items-center justify-center text-xs font-black">+</span>
                      <span className="text-[10px] font-black uppercase tracking-widest text-slate-400">Adisyon Ekle</span>
                    </div>
                    <div className="grid grid-cols-1 sm:grid-cols-6 gap-3 mb-3">
                      <div className="sm:col-span-2 relative">
                        <label className={labelClass}>Stok / Ürün Adı</label>
                        {adForm.stokAdi && !adForm._aramaModu ? (
                          <div className="flex items-center gap-2 border border-slate-200 rounded-xl px-3 py-2.5 bg-slate-50">
                            <span className="flex-1 text-sm text-slate-800 font-medium truncate">{adForm.stokAdi}</span>
                            <button type="button" onClick={() => { setAdForm(p => ({ ...p, stokAdi: '', stokId: null, _aramaModu: true })); setStokArama(''); }}
                              className="text-slate-400 hover:text-red-500 text-xs font-bold flex-shrink-0">✕</button>
                          </div>
                        ) : (
                          <div>
                            <input
                              autoFocus={adForm._aramaModu}
                              value={stokArama}
                              onChange={e => setStokArama(e.target.value)}
                              onFocus={() => setAdForm(p => ({ ...p, _dropdown: true }))}
                              onBlur={() => setTimeout(() => setAdForm(p => ({ ...p, _dropdown: false, _aramaModu: false })), 150)}
                              className={inputClass} placeholder="Ara veya yaz..."
                              autoComplete="off"
                            />
                            {adForm._dropdown && (
                              <div className="absolute left-0 top-full mt-1 bg-white border border-slate-200 rounded-xl shadow-2xl z-50 w-full max-h-52 overflow-y-auto">
                                {stoklar
                                  .filter(s => !stokArama || s.ad?.toLowerCase().includes(stokArama.toLowerCase()))
                                  .map(s => (
                                    <button key={s.stokId} type="button"
                                      onMouseDown={() => {
                                        setAdForm(p => ({
                                          ...p, stokAdi: s.ad, stokId: s.stokId,
                                          birimFiyat: s.satisFiyat || p.birimFiyat,
                                          _dropdown: false, _aramaModu: false,
                                        }));
                                        setStokArama('');
                                      }}
                                      className="w-full text-left px-4 py-2.5 text-sm hover:bg-indigo-50 hover:text-indigo-700 transition-colors flex items-center justify-between border-b border-slate-50 last:border-0">
                                      <span className="font-medium text-slate-800">{s.ad}</span>
                                      {s.satisFiyat > 0 && (
                                        <span className="text-xs text-slate-400 ml-2 flex-shrink-0">
                                          {s.satisFiyat?.toLocaleString('tr-TR')} ₺
                                        </span>
                                      )}
                                    </button>
                                  ))
                                }
                                {stokArama && !stoklar.find(s => s.ad?.toLowerCase() === stokArama.toLowerCase()) && (
                                  <button type="button"
                                    onMouseDown={() => {
                                      setAdForm(p => ({ ...p, stokAdi: stokArama, stokId: null, _dropdown: false, _aramaModu: false }));
                                      setStokArama('');
                                    }}
                                    className="w-full text-left px-4 py-2.5 text-sm text-indigo-600 hover:bg-indigo-50 border-t border-slate-100 flex items-center gap-2">
                                    <span>➕</span> "<strong>{stokArama}</strong>" olarak ekle
                                  </button>
                                )}
                                {stoklar.filter(s => !stokArama || s.ad?.toLowerCase().includes(stokArama.toLowerCase())).length === 0 && !stokArama && (
                                  <div className="px-4 py-3 text-xs text-slate-400 text-center">Stok bulunamadı</div>
                                )}
                              </div>
                            )}
                          </div>
                        )}
                      </div>
                      <div>
                        <label className={labelClass}>Miktar</label>
                        <input type="number" min="1" step="0.5" value={adForm.miktar}
                          onChange={e => setAdForm(p => ({ ...p, miktar: e.target.value }))} className={inputClass} />
                      </div>
                      <div>
                        <label className={labelClass}>Birim Fiyat (₺)</label>
                        <input type="number" min="0" value={adForm.birimFiyat}
                          onChange={e => setAdForm(p => ({ ...p, birimFiyat: e.target.value }))} className={inputClass} />
                      </div>
                    </div>
                    <div className="flex flex-col sm:flex-row items-stretch sm:items-end gap-3">
                      <div className="flex-1">
                        <label className={labelClass}>Not</label>
                        <input value={adForm.not} onChange={e => setAdForm(p => ({ ...p, not: e.target.value }))} className={inputClass} placeholder="Opsiyonel not..." />
                      </div>
                      <div className="flex items-center justify-between sm:justify-end gap-3 sm:pb-0 pb-1">
                        <div className="text-sm font-bold text-slate-700">
                          Toplam: <span className="text-indigo-600">
                            {((parseFloat(adForm.miktar) || 1) * (parseFloat(adForm.birimFiyat) || 0)).toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 4 })} ₺
                          </span>
                        </div>
                        <button onClick={handleAdisyonEkle} disabled={adKaydediliyor}
                          className="bg-gradient-to-r from-indigo-600 to-violet-600 hover:from-indigo-700 hover:to-violet-700 disabled:opacity-60 text-white px-5 py-2.5 rounded-2xl text-[10px] font-black uppercase tracking-widest transition-all shadow-sm">
                          {adKaydediliyor ? '⏳...' : '+ Ekle'}
                        </button>
                      </div>
                    </div>
                  </div>
                )}

                <div className="bg-white rounded-2xl border border-slate-100 shadow-sm overflow-x-auto">
                  {adisyonlar.length > 0 && (
                    <div className="bg-amber-50 border-b border-amber-100 px-5 py-2.5 flex items-center justify-between">
                      <span className="text-xs text-amber-700 font-semibold">Adisyon Toplamı</span>
                      <span className="text-sm font-bold text-amber-700">{adisyonToplam.toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 4 })} ₺</span>
                    </div>
                  )}
                  <DataTable
                    anahtarAlan="adisyonId"
                    satirlar={adisyonlar}
                    bosIkon="🧾"
                    bosMetin="Adisyon kaydı bulunmuyor"
                    yogun
                    kolonlar={[
                      {
                        anahtar: 'stokAdi', baslik: 'Ürün Adı', siralanir: true,
                        ciz: a => <span className="font-medium text-slate-700">{a.stokAdi}</span>,
                      },
                      {
                        anahtar: 'miktar', baslik: 'Miktar', hizala: 'orta', siralanir: true,
                        ciz: a => (
                          <div className="flex items-center gap-2">
                            <span>{a.miktar}</span>
                            {eksikBukletLoglari.some(l => l.mesaj.includes(`: ${a.stokAdi} `)) && (
                              <span className="bg-red-100 text-red-700 text-[10px] px-1.5 py-0.5 rounded-md font-bold ring-1 ring-red-200">
                                ⚠️ Eksik
                              </span>
                            )}
                          </div>
                        ),
                      },
                      {
                        anahtar: 'birimFiyat', baslik: 'Birim Fiyat', hizala: 'sag', siralanir: true,
                        ciz: a => (
                          <span className="text-slate-600 whitespace-nowrap">
                            {a.birimFiyat.toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 4 })} ₺
                          </span>
                        ),
                      },
                      {
                        anahtar: 'toplamTutar', baslik: 'Toplam', hizala: 'sag', siralanir: true,
                        ciz: a => (
                          <div className="whitespace-nowrap">
                            <span className="font-bold text-slate-800">
                              {a.toplamTutar.toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 4 })} ₺
                            </span>
                            {!a.odemeyapildiMi && a.odenenTutar > 0 && (
                              <div className="text-xs text-orange-600 mt-0.5">
                                Kalan: {(a.toplamTutar - a.odenenTutar).toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 4 })} ₺
                              </div>
                            )}
                          </div>
                        ),
                      },
                      {
                        anahtar: 'not', baslik: 'Not',
                        ciz: a => <span className="text-slate-400 text-xs">{a.not || '—'}</span>,
                      },
                      {
                        anahtar: 'olusturmaTarihi', baslik: 'Tarih', siralanir: true,
                        ciz: a => <span className="text-slate-400 text-xs whitespace-nowrap">{fmt(a.olusturmaTarihi)}</span>,
                      },
                      {
                        anahtar: 'islem', baslik: 'İşlem', hizala: 'sag',
                        ciz: a => (
                          <div className="flex items-center gap-1.5 justify-end">
                            {!readonly && !a.odemeyapildiMi && a.toplamTutar > 0 && (
                              <button onClick={async () => {
                                const [tipler, bankalar] = await Promise.all([
                                  apiRequest('odemetipleri').catch(() => []),
                                  apiRequest('bankatanimlari').catch(() => []),
                                ]);
                                setAdisyonOdeTipleri(tipler || []);
                                setAdisyonBankalar(bankalar || []);
                                const ilkTip = tipler?.[0]?.ad || 'Nakit';
                                const kalan = a.toplamTutar - (a.odenenTutar || 0);
                                setAdisyonOdeForm({ odemeTipi: ilkTip, paraBirimi: 'TL', bankaAdi: '', tutar: String(kalan > 0 ? kalan : a.toplamTutar) });
                                setAdisyonOdeModal({ adisyonId: a.adisyonId, stokAdi: a.stokAdi, toplamTutar: a.toplamTutar, odenenTutar: a.odenenTutar || 0 });
                              }} className="bg-green-50 hover:bg-green-100 text-green-700 text-xs px-3 py-1.5 rounded-lg font-semibold ring-1 ring-green-200 transition-colors">
                                💳 Öde
                              </button>
                            )}
                            {!readonly && !a.isBuklet && (
                              <button onClick={async () => {
                                if (!window.confirm('Adisyon silinsin mi?')) return;
                                await apiRequest(`adisyonlar/${a.adisyonId}`, 'DELETE');
                                await veriYukle();
                              }} className="bg-red-50 hover:bg-red-100 text-red-600 text-xs px-3 py-1.5 rounded-lg font-semibold ring-1 ring-red-200 transition-colors">
                                Sil
                              </button>
                            )}
                          </div>
                        ),
                      },
                    ]}
                  />
                </div>
              </div>
            )}

            {/* ── TAB 4: E-FATURA ── */}
            {aktifTab === 'E-fatura' && (
              <div className="p-4 md:p-6 space-y-4" style={{ animation: 'slideIn 0.2s ease-out' }}>
                {/* Başlık + Fatura Kes butonu */}
                <div className="flex items-center justify-between">
                  <div>
                    <p className="text-sm font-bold text-slate-700">Kesilen E-Faturalar</p>
                    <p className="text-xs text-slate-400 mt-0.5">Bu rezervasyona ait tüm e-fatura kayıtları</p>
                  </div>
                  <button
                    onClick={() => setFaturaModalAcik(true)}
                    className="flex items-center gap-2 bg-indigo-600 hover:bg-indigo-700 text-white text-xs font-bold px-4 py-2.5 rounded-xl transition-colors shadow-sm"
                  >
                    <span>⚡</span> Fatura Kes
                  </button>
                </div>

                {/* Liste */}
                {efaturaYukleniyor ? (
                  <div className="flex items-center justify-center py-12 text-slate-400 text-sm">Yükleniyor...</div>
                ) : efaturaListesi.length === 0 ? (
                  <div className="bg-slate-50 rounded-2xl border border-slate-100 p-10 text-center">
                    <div className="w-14 h-14 bg-white border border-slate-200 rounded-2xl flex items-center justify-center text-2xl mx-auto mb-3 shadow-sm">📄</div>
                    <p className="text-slate-500 font-semibold text-sm mb-1">Henüz fatura kesilmedi</p>
                    <p className="text-slate-400 text-xs">Yukarıdaki butona tıklayarak fatura kesebilirsiniz.</p>
                  </div>
                ) : (
                  <div className="space-y-2">
                    {efaturaListesi.map(f => {
                      const durumRenk = f.gibDurumu === 'BEKLEMEDE' ? 'bg-amber-100 text-amber-700'
                        : f.gibDurumu === 'BAŞARILI' ? 'bg-emerald-100 text-emerald-700'
                        : 'bg-rose-100 text-rose-700';
                      return (
                        <div key={f.gidenEFaturaId} className="bg-white rounded-2xl border border-slate-100 shadow-sm p-4 flex flex-col sm:flex-row sm:items-center gap-3">
                          <div className="flex-1 min-w-0">
                            <div className="flex items-center gap-2 flex-wrap">
                              <span className="text-xs font-black text-slate-700 font-mono">{f.faturaNo}</span>
                              <span className="text-[10px] bg-slate-100 text-slate-500 font-bold px-2 py-0.5 rounded-lg">{f.faturaTipi}</span>
                              <span className={`text-[10px] font-bold px-2 py-0.5 rounded-lg ${durumRenk}`}>{f.gibDurumu}</span>
                            </div>
                            <p className="text-xs text-slate-500 mt-1 truncate">{f.aliciAdi} — {f.aliciTcVergiNo}</p>
                            <p className="text-[11px] text-slate-400 mt-0.5">
                              {new Date(f.tarih).toLocaleDateString('tr-TR', { day: '2-digit', month: 'long', year: 'numeric' })}
                              {f.odemeTipi ? ` · ${f.odemeTipi}` : ''}
                            </p>
                          </div>
                          <div className="flex-shrink-0 text-right">
                            <p className="text-base font-black text-emerald-600">{(f.genelToplam || 0).toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 4 })} ₺</p>
                            <p className="text-[10px] text-slate-400">KDV: {(f.kdvTutari || 0).toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 4 })} ₺</p>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                )}
              </div>
            )}

            {/* ── TAB 5: EVRAKLAR ── */}
            {aktifTab === 'Evraklar' && (
              <EvraklarTab rezervasyonId={rezervasyonId} readonly={readonly} onLogGuncelle={veriYukle} />
            )}

            {/* ── TAB 6: LOG ── */}
            {aktifTab === 'Log' && (
              <div className="p-3 md:p-6 space-y-4" style={{ animation: 'slideIn 0.2s ease-out' }}>
                <div className="bg-white rounded-2xl border border-slate-100 shadow-sm p-5">
                  <div className="flex items-center gap-2 mb-4">
                    <span className="w-6 h-6 bg-gradient-to-br from-slate-600 to-slate-800 text-white rounded-xl flex items-center justify-center text-xs font-black">+</span>
                    <span className="text-[10px] font-black uppercase tracking-widest text-slate-400">Not / Log Ekle</span>
                  </div>
                  <div className="flex flex-col sm:flex-row gap-3">
                    <div className="flex-1">
                      <input value={logMesaj} onChange={e => setLogMesaj(e.target.value)}
                        placeholder="Log notu giriniz..." className={inputClass}
                        onKeyDown={e => e.key === 'Enter' && !logKaydediliyor && handleLogEkle()} />
                    </div>
                    <div className="flex gap-3">
                      <div className="flex-1 sm:w-36 sm:flex-none">
                        <select value={logTip} onChange={e => setLogTip(e.target.value)} className={inputClass}>
                          <option value="Bilgi">Bilgi</option>
                          <option value="İşlem">İşlem</option>
                          <option value="Uyarı">Uyarı</option>
                          <option value="Not">Not</option>
                        </select>
                      </div>
                      <button onClick={handleLogEkle} disabled={logKaydediliyor}
                        className="bg-gradient-to-r from-indigo-600 to-violet-600 hover:from-indigo-700 hover:to-violet-700 disabled:opacity-60 text-white px-5 py-2.5 rounded-2xl text-[10px] font-black uppercase tracking-widest transition-all shadow-sm flex-shrink-0">
                        {logKaydediliyor ? '⏳' : '+ Ekle'}
                      </button>
                    </div>
                  </div>
                </div>

                {loglar.length === 0 ? (
                  <div className="bg-white rounded-2xl border border-slate-100 shadow-sm p-10 text-center text-slate-400">
                    <div className="w-12 h-12 bg-slate-100 rounded-2xl flex items-center justify-center text-2xl mx-auto mb-3">📋</div>
                    <p className="text-sm">Henüz log kaydı bulunmuyor</p>
                  </div>
                ) : (
                  <div className="space-y-2">
                    {loglar.map((log, i) => {
                      const tipConfig = {
                        'İşlem': { bg: 'bg-indigo-50 border-indigo-100', badge: 'bg-indigo-100 text-indigo-700 ring-indigo-200', dot: 'bg-indigo-500' },
                        'Uyarı': { bg: 'bg-amber-50 border-amber-100', badge: 'bg-amber-100 text-amber-700 ring-amber-200', dot: 'bg-amber-500' },
                        'Not': { bg: 'bg-purple-50 border-purple-100', badge: 'bg-purple-100 text-purple-700 ring-purple-200', dot: 'bg-purple-500' },
                        'Bilgi': { bg: 'bg-slate-50 border-slate-100', badge: 'bg-slate-100 text-slate-600 ring-slate-200', dot: 'bg-slate-400' },
                        'Otomatik': { bg: 'bg-teal-50 border-teal-100', badge: 'bg-teal-100 text-teal-700 ring-teal-200', dot: 'bg-teal-500' },
                      }[log.tip] || { bg: 'bg-slate-50 border-slate-100', badge: 'bg-slate-100 text-slate-600 ring-slate-200', dot: 'bg-slate-400' };

                      return (
                        <div key={log.rezervasyonLogId}
                          className={`rounded-2xl border p-4 ${tipConfig.bg} flex items-start gap-3 hover:shadow-sm transition-shadow`}>
                          <div className={`w-2 h-2 rounded-full mt-1.5 flex-shrink-0 ${tipConfig.dot}`}></div>
                          <div className="flex-1 min-w-0">
                            <div className="flex items-center gap-2 mb-1 flex-wrap">
                              <span className={`text-xs font-bold px-2 py-0.5 rounded-lg ring-1 ${tipConfig.badge}`}>{log.tip}</span>
                              <span className="text-xs text-slate-400">
                                {fmt(log.olusturmaTarihi)} {new Date(log.olusturmaTarihi.includes('Z') ? log.olusturmaTarihi : log.olusturmaTarihi + 'Z').toLocaleTimeString('tr-TR', { hour: '2-digit', minute: '2-digit' })}
                              </span>
                              {log.personelAd && (
                                <span className="text-xs text-slate-500">· {log.personelAd}</span>
                              )}
                            </div>
                            <p className="text-sm text-slate-700">{log.mesaj}</p>
                          </div>
                          <button onClick={async () => {
                            if (!window.confirm('Log silinsin mi?')) return;
                            await apiRequest(`rezervasyon-loglari/${log.rezervasyonLogId}`, 'DELETE');
                            await veriYukle();
                          }} className="text-slate-300 hover:text-red-400 transition-colors text-xs font-bold flex-shrink-0">
                            ✕
                          </button>
                        </div>
                      );
                    })}
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
      </div>

      {popup === 'odeme' && (
        <OdemeAlPopup
          onClose={() => setPopup(null)}
          rezervasyonId={rezervasyonId}
          personelId={personel?.personelId || 1}
          kalanBakiye={kalanBakiye}
          onKaydedildi={async () => { await veriYukle(); onGuncelle?.(); }}
        />
      )}
      {popup === 'checkout' && (
        <CheckOutPopup
          onClose={() => setPopup(null)}
          rez={{ ...rez, alinanToplam, adisyonToplam }}
          onCheckOut={async () => { await veriYukle(); onGuncelle?.(); }}
          onOdemeAc={() => setPopup('odeme')}
        />
      )}
      {misafirDuzenle && (
        <MisafirDuzenlePopup
          misafir={misafirDuzenle}
          onClose={() => setMisafirDuzenle(null)}
          onKaydedildi={async () => { await veriYukle(); }}
        />
      )}

      {misafirEkleAcik && (
        <MisafirEklePopup
          rezervasyonId={rezervasyonId}
          onClose={() => setMisafirEkleAcik(false)}
          onEklendi={async () => { await veriYukle(); }}
        />
      )}

      {/* Otomatik Uzatma — Onay Modalı */}
      {uzatmaModal === 'onay' && (
        <div className="fixed inset-0 z-[10500] flex items-center justify-center p-4"
          style={{ backdropFilter: 'blur(12px)', background: 'rgba(15,23,42,0.65)' }}
          onClick={() => setUzatmaModal(null)}>
          <div className="bg-white rounded-[2rem] shadow-2xl p-6 w-full max-w-sm border border-white/20" onClick={e => e.stopPropagation()}>
            <div className="text-center mb-4">
              <div className="w-14 h-14 bg-teal-50 rounded-2xl flex items-center justify-center text-3xl mx-auto mb-3">🔄</div>
              <h3 className="font-black text-slate-800 text-sm">Rezervasyonu Uzat</h3>
              <p className="text-xs text-slate-500 mt-1">
                Çıkış tarihi <strong>{rez?.cikisTarihi ? new Date(rez.cikisTarihi).toLocaleDateString('tr-TR') : '?'}</strong> olan bu rezervasyon
                1 gün uzatılacak ve ücret adisyona eklenecektir.
              </p>
            </div>
            <div className="flex gap-2">
              <button onClick={() => setUzatmaModal(null)}
                className="flex-1 border border-slate-200 text-slate-600 text-[10px] font-black uppercase tracking-widest py-2.5 rounded-2xl hover:bg-slate-50 transition-colors">
                İptal
              </button>
              <button onClick={async () => {
                setUzatmaModal(null);
                try {
                  const res = await apiRequest(`rezervasyonlar/${rez.rezervasyonId}/otomatik-uzat`, 'POST');
                  if (res?.uzatilanSayisi > 0) {
                    await veriYukle();
                    setUzatmaModal({ basarili: true, mesaj: res.mesajlar?.[0] || 'Uzatıldı.' });
                  } else {
                    setUzatmaModal({ basarili: false, mesaj: res?.mesajlar?.[0] || 'Uzatılamadı.' });
                  }
                } catch (e) {
                  setUzatmaModal({ basarili: false, mesaj: e?.message || 'Sunucu hatası.' });
                }
              }} className="flex-1 bg-teal-600 hover:bg-teal-700 text-white text-[10px] font-black uppercase tracking-widest py-2.5 rounded-2xl transition-colors">
                Uzat
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Otomatik Uzatma — Sonuç Modalı */}
      {uzatmaModal && typeof uzatmaModal === 'object' && (
        <div className="fixed inset-0 z-[10500] flex items-center justify-center p-4"
          style={{ backdropFilter: 'blur(12px)', background: 'rgba(15,23,42,0.65)' }}
          onClick={() => setUzatmaModal(null)}>
          <div className="bg-white rounded-[2rem] shadow-2xl p-6 w-full max-w-sm text-center border border-white/20" onClick={e => e.stopPropagation()}>
            <div className={`w-14 h-14 ${uzatmaModal.basarili ? 'bg-teal-50' : 'bg-amber-50'} rounded-2xl flex items-center justify-center text-3xl mx-auto mb-3`}>
              {uzatmaModal.basarili ? '✅' : '⚠️'}
            </div>
            <h3 className="font-black text-slate-800 text-sm mb-2">{uzatmaModal.basarili ? 'Uzatma Başarılı' : 'Uzatılamadı'}</h3>
            <p className="text-sm text-slate-600 mb-4">{uzatmaModal.mesaj}</p>
            <button onClick={() => setUzatmaModal(null)}
              className="w-full bg-slate-100 hover:bg-slate-200 text-slate-700 text-[10px] font-black uppercase tracking-widest py-2.5 rounded-2xl transition-colors">
              Tamam
            </button>
          </div>
        </div>
      )}

      {/* Adisyon Ödeme Modalı */}
      {adisyonOdeModal && (
        <div className="fixed inset-0 z-[10500] flex items-center justify-center p-4"
          style={{ backdropFilter: 'blur(12px)', background: 'rgba(15,23,42,0.65)' }}
          onClick={() => setAdisyonOdeModal(null)}>
          <div className="bg-white rounded-[2rem] shadow-2xl p-5 w-full max-w-md max-h-[90vh] overflow-y-auto border border-white/20" onClick={e => e.stopPropagation()}>
            <h3 className="text-[10px] font-black uppercase tracking-widest text-slate-500 mb-4">💳 Adisyon Ödemesi</h3>
            {(() => {
              const kur = dovizKurlari?.[adisyonOdeForm.paraBirimi] || 1;
              const girilTutar = parseFloat(adisyonOdeForm.tutar) || 0;
              const tlKarsiligi = adisyonOdeForm.paraBirimi !== 'TL' && girilTutar > 0 ? (girilTutar * kur).toFixed(2) : null;
              const girilTutarTL = girilTutar * kur;
              const kalanTutar = adisyonOdeModal.toplamTutar - adisyonOdeModal.odenenTutar;
              const fazlaOdeme = girilTutarTL > kalanTutar;
              const kismiOdeme = girilTutar > 0 && girilTutarTL < kalanTutar;
              const nakit = adisyonOdeForm.odemeTipi &&
                (adisyonOdeForm.odemeTipi.localeCompare('Nakit', 'tr', { sensitivity: 'base' }) === 0 ||
                  adisyonOdeForm.odemeTipi.localeCompare('NAKİT', 'tr', { sensitivity: 'base' }) === 0);
              return (
                <>
                  <div className="bg-amber-50 border border-amber-200 rounded-xl px-4 py-3 mb-4">
                    <div className="text-xs text-amber-700 font-semibold">{adisyonOdeModal.stokAdi}</div>
                    <div className="text-lg font-bold text-amber-800 mt-0.5">
                      {kalanTutar.toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 4 })} ₺ kalan
                    </div>
                    {adisyonOdeModal.odenenTutar > 0 && (
                      <div className="text-xs text-amber-600 mt-0.5">
                        Toplam: {adisyonOdeModal.toplamTutar.toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 4 })} ₺ · Ödenen: {adisyonOdeModal.odenenTutar.toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 4 })} ₺
                      </div>
                    )}
                  </div>
                  <div className="space-y-3">
                    <div className="flex gap-3">
                      <div className="flex-1">
                        <label className={labelClass}>Ödenecek Tutar</label>
                        <input type="number" min="0" step="0.01"
                          value={adisyonOdeForm.tutar}
                          onChange={e => setAdisyonOdeForm(p => ({ ...p, tutar: e.target.value }))}
                          className={inputClass} />
                      </div>
                      <div className="w-28">
                        <label className={labelClass}>Para Birimi</label>
                        <select value={adisyonOdeForm.paraBirimi} onChange={e => setAdisyonOdeForm(p => ({ ...p, paraBirimi: e.target.value }))}
                          className={inputClass}>
                          <option value="TL">TL</option>
                          {paraBirimiListesi.filter(p => p !== 'TL' && p !== 'TRY').map(p => (
                            <option key={p} value={p}>{p}</option>
                          ))}
                        </select>
                      </div>
                    </div>
                    <div className="flex gap-3">
                      <div className="flex-1">
                        <label className={labelClass}>Ödeme Tipi</label>
                        <select value={adisyonOdeForm.odemeTipi} onChange={e => setAdisyonOdeForm(p => ({ ...p, odemeTipi: e.target.value, bankaAdi: '' }))}
                          className={inputClass}>
                          {(adisyonOdeTipleri.length > 0 ? adisyonOdeTipleri.map(t => t.ad) : ['Nakit', 'Kredi Kartı', 'Havale/EFT', 'Çek']).map(t => (
                            <option key={t}>{t}</option>
                          ))}
                        </select>
                      </div>
                    </div>
                    {tlKarsiligi && (
                      <div className="text-xs text-slate-500 bg-slate-50 rounded-lg px-3 py-2">
                        ≈ {tlKarsiligi} TL (1 {adisyonOdeForm.paraBirimi} = {kur.toFixed(4)} TL)
                      </div>
                    )}
                    {kismiOdeme && (
                      <div className="text-xs bg-orange-50 border border-orange-200 rounded-lg px-3 py-2 text-orange-700 space-y-0.5">
                        <div className="font-semibold">⚠️ Kısmi ödeme</div>
                        <div>TL karşılığı <strong>{girilTutarTL.toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 4 })} ₺</strong>, kalan tutar <strong>{kalanTutar.toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 4 })} ₺</strong>.</div>
                        <div>Ödeme kaydedilir fakat adisyon <strong>Bekliyor</strong> olarak kalır.</div>
                      </div>
                    )}
                    {fazlaOdeme && (
                      <div className="text-xs bg-amber-50 border border-amber-200 rounded-lg px-3 py-2 text-amber-700 space-y-0.5">
                        <div className="font-semibold">⚠️ Fazla ödeme</div>
                        <div>Kalan tutar: <strong>{kalanTutar.toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 4 })} ₺</strong></div>
                        <div>Fazla tutar: <strong>{(girilTutarTL - kalanTutar).toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 4 })} ₺</strong> → rezervasyonun kalan borcuna mahsup edilir.</div>
                      </div>
                    )}
                    {!nakit && adisyonBankalar.length > 0 && (
                      <div>
                        <label className={labelClass}>Banka</label>
                        <select value={adisyonOdeForm.bankaAdi} onChange={e => setAdisyonOdeForm(p => ({ ...p, bankaAdi: e.target.value }))}
                          className={inputClass}>
                          <option value="">Seçiniz</option>
                          {adisyonBankalar.map(b => <option key={b.bankaTanimiId} value={b.ad}>{b.ad}</option>)}
                        </select>
                      </div>
                    )}
                  </div>
                  <div className="flex gap-3 mt-5">
                    <button onClick={() => setAdisyonOdeModal(null)}
                      className="flex-1 bg-slate-100 hover:bg-slate-200 text-slate-600 py-2.5 rounded-2xl text-[10px] font-black uppercase tracking-widest">
                      İptal
                    </button>
                    <button disabled={adisyonOdeniyor} onClick={async () => {
                      setAdisyonOdeniyor(true);
                      try {
                        const kurDegeri = adisyonOdeForm.paraBirimi === 'TL' ? 1 : (dovizKurlari?.[adisyonOdeForm.paraBirimi] || 1);
                        await apiRequest(`adisyonlar/${adisyonOdeModal.adisyonId}/ode`, 'POST', {
                          tutar: parseFloat(adisyonOdeForm.tutar) || null,
                          odemeTipi: adisyonOdeForm.odemeTipi,
                          paraBirimi: adisyonOdeForm.paraBirimi,
                          kurDegeri,
                          bankaAdi: adisyonOdeForm.bankaAdi || '',
                          personelId: personel?.personelId || null,
                        });
                        setAdisyonOdeModal(null);
                        await veriYukle();
                        onGuncelle?.();
                      } catch (e) {
                        alert(e.message || 'Ödeme başarısız.');
                      } finally {
                        setAdisyonOdeniyor(false);
                      }
                    }} className="flex-1 bg-gradient-to-r from-emerald-600 to-teal-600 hover:from-emerald-700 hover:to-teal-700 disabled:opacity-60 text-white py-2.5 rounded-2xl text-[10px] font-black uppercase tracking-widest shadow-md">
                      {adisyonOdeniyor ? '⏳...' : 'Ödemeyi Onayla'}
                    </button>
                  </div>
                </>
              );
            })()}
          </div>
        </div>
      )}

      {faturaModalAcik && (() => {
        const ilkMisafir = rez?.rezervasyonMisafirler?.[0]?.misafir;
        const giris = rez?.girisTarihi ? new Date(rez.girisTarihi) : null;
        const cikis = rez?.cikisTarihi ? new Date(rez.cikisTarihi) : null;
        const geceSayisi = giris && cikis
          ? Math.round((cikis - giris) / 86400000)
          : giris
            ? Math.max(1, Math.floor((Date.now() - giris.getTime()) / 86400000))
            : 1;
        const faturaBirimFiyat = (rez?.fiyatTipi === 'Gecelik ücret' && !cikis)
          ? (rez?.odaTutari || 0)
          : geceSayisi > 0 ? Math.round(((rez?.odaTutari || 0) / geceSayisi) * 10000) / 10000 : (rez?.odaTutari || 0);
        return (
          <YeniFaturaModal
            onKapat={() => setFaturaModalAcik(false)}
            onFaturaKesildi={() => { setFaturaModalAcik(false); efaturaYukle(); }}
            rezervasyon={{
              rezervasyonId: rezervasyonId,
              misafirAdi:    ilkMisafir?.adSoyad || '',
              tcNo:          ilkMisafir?.tcPasaportNo || ilkMisafir?.pasaportNo || '',
              email:         ilkMisafir?.email || '',
              sehir:         ilkMisafir?.sehir || '',
              ilce:          ilkMisafir?.ilce || '',
              adres:         ilkMisafir?.adres || '',
              odaTutari:     faturaBirimFiyat,
              geceSayisi,
              odaAdi:        rez?.odaNo || '',
              adisyonlar:    adisyonlar || [],
              firmaId:       rez?.firmaId || null,
            }}
          />
        );
      })()}

      <style>{`
        @keyframes fadeIn { from { opacity: 0; } to { opacity: 1; } }
        @keyframes slideIn { from { opacity: 0; transform: translateY(6px); } to { opacity: 1; transform: translateY(0); } }
      `}</style>
    </>
    , document.body
  );
}
